
<template>
  <div>
    <div class="breadcrumbs" v-if="sflag">
      <div class="w">
        <el-breadcrumb separator="/">
          <el-breadcrumb-item>首页</el-breadcrumb-item>
          <el-breadcrumb-item>{{productParams.product.product_name}}</el-breadcrumb-item>
        </el-breadcrumb>
        <input type="hidden" id="cate-id" name="cate-id" :value="productParams.product.product_id" />
      </div>
    </div>
    <div class="body">
      <div :class="sflag ? 'w' : ''">
        <div class="sy-detail-bd clearfix">
          <div class="sy-item-info-l">
            <div class="sy-gallery">
              <div class="sy-booth">
                <div :class="hotImg ? 'by_bg' : ''"></div>
                <a href="javascript:;">
                  <img v-if="imgUrl!==''" :src="imgUrl" style="width:100%" />
                  <img v-else src="../../assets/images/timg.jpg" style="width:100%" />
                </a>
              </div>
              <div class="sy-thumb clearfix">
                <ul class="clearfix">
                  <!-- <li>
                    <a href="javascript:;">
                      <img :src="productParams.product.product_img" />
                    </a>
                  </li>
                  <template v-if="JSON.stringify(ImgList)!='[]'">
                    <li v-for="(item,index) in ImgList" :key="index">
                      <a href="javascript:;">
                        <img :src="baseUrl+item.path" />
                      </a>
                    </li>
                  </template>-->
                  <swiper class="smallImgBox" :options="swiperOption">
                    <swiper-slide>
                      <a href="javascript:;">
                        <img style="width:60px;height:55px;" :src="productParams.product.product_img" />
                      </a>
                    </swiper-slide>
                    <template v-if="JSON.stringify(ImgList)!='[]'">
                      <swiper-slide v-for="(item,index) in ImgList" :key="index">
                        <a href="javascript:;">
                          <img style="width:60px;height:55px;" :src="item.path" />
                        </a>
                      </swiper-slide>
                    </template>
                  </swiper>
                </ul>
              </div>
            </div>
          </div>
          <div class="sy-item-info-r">
            <div class="sy-info-title clearfix">
              <div class="left">{{productParams.product.product_name}}</div>
			  <div class="right" style="font-size: 18px;color: orangered;display: contents;">
				  <div style="float: right;" ><a href="javascript:;" @click="chongzhi()">充值</a></div>
				  <div style="float: right;">余额：<span class="user_money">{{user_money}}元</span></div>
				  </div>
            </div>

            <div class="sy-info-price clearfix">
              <div class="left">
                <div class="price">
                  <span>
                    价 &nbsp;&nbsp;格:
                    <i class="money"  v-if="price!=='' && factory_discount>0 && factory_discount<100">{{'￥'+price+'元'}}</i>
                    <i class="money" style="color: red; font-size: 32px;"  v-if="price!=='' && factory_discount == 100 ">{{'￥'+price+'元'}}</i>
                    <i class="mone" style="font-size:24px;color:red" v-else></i>
                    <b v-show="hotImg">{{hotImg}}</b>
                  </span>
                  <strong v-if="price!=='' && factory_discount>0 && factory_discount<100 && discount_price">{{factory_discount}}折优惠:{{discount_price}}元</strong>
                </div>
				<div class="help">
					<a href="javascript:;" @click="payVideo('demo_video')">下单演示</a>
					<a href="javascript:;" @click="payVideo('product_train')">产品培训</a>
				</div>
                <div class="select_product_info" v-if="productName&&productName.indexOf('选择')==-1  && (productParams.product.product_id==95 || productParams.product.product_id==5) ">
                  {{productName}}
                  {{'_'+kuanshu+'款'}}
                </div>
                <div class="select_product_info" v-else-if="productName&&productName.indexOf('选择')==-1">
                  {{productName+'_'}}
                  {{demo}}
                  {{'_'+kuanshu+'款'}}
                </div>
                <div class="favorable"  v-if="productName&&productName.indexOf('选择')==-1">
                    <a href="javascript:;" @click="copyproduct()">复制</a>
                </div>
              </div>
              <!-- <div class="right">
                <a class="xiaoshou">
                  <p class="description">销售量</p>
                  <p class="sy-count">12451</p>
                </a>
                <a class="assess">
                  <p class="description">评价</p>
                  <p class="sy-count">3706</p>
                </a>
              </div>-->
            </div>
            <div class="sy-skin">
              
              <dl class="sy-prop clearfix" v-for="(item,index) in productParams.product_type" :key="index">
                <dt>{{item.type_name}}:</dt>
                <dd>
                  <ul class="clearfix product_size" v-if="item.display_type=='product_btn_custom' && item.type_name=='产品尺寸'">
                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>
                    <li class="save_count">自定义</li>
                    <div class="dy product_chicun" v-if="item.display_list[0].split('X').length - 1==2">
                      <el-popover ref="popover" placement="top-start" class="chicunlimitdesc" width="550" trigger="click" content="请填写完整,高最大450mm，宽最大630mm,厚最大280mm"></el-popover>
                      <input type="text" id="chang" placeholder="高" oninput="value=value.replace(/[^\d]/g,'')"
                        v-popover:popover open-delay:10 />×
                      <el-popover ref="popover11" placement="top-start"class="chicunlimitdesc" width="550" trigger="click" content="请填写完整,高最大450mm，宽最大630mm,厚最大280mm"></el-popover>
                      <input type="text" id="kuan" placeholder="宽" oninput="value=value.replace(/[^\d]/g,'')"
                        v-popover:popover11 />×
                      <el-popover ref="popover22" placement="top-start" class="chicunlimitdesc" width="550" trigger="click" content="请填写完整,高最大450mm，宽最大630mm,厚最大280mm"></el-popover>
                      <input type="text" id="hou" placeholder="厚" oninput="value=value.replace(/[^\d]/g,'')"
                        v-popover:popover22 />
                      mm
                    </div>

                    <div class="dy product_chicun" v-else>
                      <el-popover ref="popover" placement="top-start" class="chicunlimitdesc" width="550"  trigger="click" :content="chicunlimitdesc"></el-popover>
                      <input type="text" id="chang" placeholder="长" oninput="value=value.replace(/[^\d]/g,'')"
                        v-popover:popover open-delay:10 />×
                      <el-popover ref="popover11" placement="top-start" class="chicunlimitdesc" width="550" trigger="click" :content="chicunlimitdesc"></el-popover>
                      <input type="text" id="kuan" placeholder="宽" oninput="value=value.replace(/[^\d]/g,'')"
                        v-popover:popover11 />
                    </div>
                    &nbsp; &nbsp;<span class="kgh" style="color:red"> </span>
                  </ul>
                  <ul class="clearfix product_size" v-if="item.display_type=='product_btn' && item.type_name=='产品尺寸'">
                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>
      </ul>
                  <ul class="clearfix product_size" v-if="item.display_type=='product_select' && item.type_name=='产品尺寸'">
                  <select id="selectselBox" >
                                     <option value>请选择产品尺寸</option>
                                     <option v-for="(uu,i) in item.display_list" :key="i" :value="uu">{{uu}}</option>
                                   </select>
                                 </ul>
                  <!-- 样本画册判断 -->

                  <ul class="clearfix product_size fmzhi" v-else-if="item.display_type=='product_btn' && (productParams.product.product_id=='95' || productParams.product.product_id=='5')&& item.type_name=='封面用纸'">
                    <select   v-model="fmzhileiseledct" class="fmzhilei" @change='getzhizhang' style="float: left;width: 100px;height: 27px;">
                      <option value='0'>请选择封面用纸</option>
                      <option v-for="(uuu,iii) in zhilei" :key="iii" :value="iii">{{uuu}}</option>
                    </select>
                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>
                  </ul>
                  <ul class="clearfix product_size nwzhi" v-else-if="item.display_type=='product_btn' && (productParams.product.product_id=='95' || productParams.product.product_id=='5')&& item.type_name=='内文用纸'">
                    <select v-model="nwzhileiseledct"  class="nwzhilei" @change='getzhizhang' style="float: left;width: 100px;height: 27px;">
                      <option value='0'>请选择内文用纸</option>
                      <option v-for="(uuu,iii) in zhilei" :key="iii" :value="iii" >{{uuu}}</option>
                    </select>
                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>
                  </ul>
                  <!--  -->
                  <ul class="clearfix product_size" v-else-if="item.display_type=='product_btn' && (productParams.product.product_id=='95' || productParams.product.product_id=='5')&& item.type_name=='封面握口'">

                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>
                    <div >
                     <dd :class="Cflag ? 'di' : ''" style="margin-left: 20px;">
                      <el-input-number :step="1" class="wokou" style="display: none;" v-model="wokou" @change="handleChangewokou" :min="0" :max="9999999" size="small"></el-input-number>
                      <span class="wokoucm" style="display: none;">CM</span>
                  </dd>
                   <dd :class="Cflag ? 'di' : ''" style="margin-left: 90px;">
                     <span>烫金工艺:</span>
                    <el-input-number :step="1" v-model="tjnum" @change="handleChangetjnum" :min="0" :max="9999999" size="small"></el-input-number>处
                  </dd>
                  </div>
                  </ul>

                  <!--  -->
                  <ul class="clearfix product_size nwysgy" v-else-if="item.display_type=='product_btn' && (productParams.product.product_id=='95' || productParams.product.product_id=='5') && item.type_name=='内文印刷工艺'">

                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>

                   <dd :class="Cflag ? 'di' : ''" style="margin-left: 30px;">
                     <span>内文P数:</span>
                    <el-input-number :step="inputstep" name="npnum" v-model="npnum" @change="handleChangenpnum" :min="2" :max="9999999" size="small"></el-input-number>P
                  <span class="tips" style="color: red;" >  </span>
                  </dd>
                  </ul>
                  <!--  -->

                  <ul class="clearfix product_zhonglei" v-else-if="index==0">
                    <template v-if="item.display_type == 'product_select'">
                      <select id="selBox" >
                        <option value>请选择产品种类</option>
                        <option v-for="(uu,i) in item.display_list" :key="i" :value="uu">{{uu}}</option>
                      </select>
                    </template>
                    <template v-else>
                      <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>
                    </template>
                  </ul>

                  <ul class="clearfix product_Count" v-else-if="item.type_name=='印刷数量'">
                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}{{productParams.product.product_unit}}</li>
                    <li class="save_count">自定义</li>
                    <div class="dy product_count">
                      <el-popover ref="popover2" placement="top-start" width="165" trigger="click" :content="'自定义数量最少是,'+minNum"></el-popover>
                      <input type="text" id="zidingy" placeholder="数量" oninput="value=value.replace(/[^\d]/g,'')"
                        v-popover:popover2 />
                    </div>
                  </ul>
                  <ul class="clearfix product_Count" v-else-if="item.display_type=='product_btn_custom' && item.type_name=='张数工艺'">
                    <li v-for="(uu,i) in item.display.split(',')" :key="i">{{uu}}</li>
                    <li class="save_count">自定义</li>
                    <div class="dy product_count">
                      <el-popover ref="popover2" placement="top-start" width="165" trigger="click":content="'自定义数量最少是,'+minNum"></el-popover>
                      <input type="text" id="zidingy2" placeholder="张数" oninput="value=value.replace(/[^\d]/g,'')"
                        v-popover:popover2 />张/本
                    </div>
                  </ul>

                  <ul class="clearfix" v-else-if="item.display_type=='product_radio'">
                    <div class="danxuan">
                      <div class="sy_fdanxuan" style="display:inline-block;margin-right:10px" v-for="(item0,index0) in item.display_list"
                        :key="index0">
                        <div style="float:left;margin-top:5px">
                          <i style="display:none">{{randomNum = (randomId+index0+Math.random()*1000)}}</i>
                          <input type="radio" :id="item.type_id+randomNum" :value="item0" />
                          <label :for="item.type_id+randomNum">{{item0}}</label>
                        </div>
                      </div>
                    </div>
                  </ul>
                  <ul class="clearfix" v-else-if="item.display_type=='product_radio_custom'">
                    <div class="danxuan">
                      <div class="sy_fdanxuan" style="display:inline-block;margin-right:10px" v-for="(item0,index0) in item.display_list"
                        :key="index0">
                        <div style="float:left;margin-top:5px">
                          <i style="display:none">{{randomNum = (randomId+index0+Math.random()*1000)}}</i>
                          <input type="radio" :id="item.type_id+randomNum" />
                          <label :for="item.type_id+randomNum">{{item0}}</label>
                        </div>
                        <div class="dy sy_zdydanxuan" style="margin-left:0; margin-right:5px">
                          <el-popover ref="popover5" placement="top-start" width="100" trigger="click" content="请填写完整,最大值840"></el-popover>
                          <input type="text" id="chang1" placeholder="长" oninput="value=value.replace(/[^\d]/g,'')"
                            v-popover:popover5 open-delay:10 />×
                          <el-popover ref="popover1" placement="top-start" width="100" trigger="click" content="请填写完整,最大值570"></el-popover>
                          <input type="text" id="kuan1" max="700" placeholder="宽" oninput="value=value.replace(/[^\d]/g,'')"
                            v-popover:popover1 />
                          mm
                        </div>
                      </div>
                    </div>
                  </ul>
                  <ul class="clearfix product_zl" v-else-if="item.display!==null&&item.display_type!=='product_checkbox' && item.type_name !='做袋工艺'&& item.type_name !='产品尺寸' ">
                    <li v-for="(u,i) in item.display_list" :key="i">{{u}}</li>
                  </ul>

                  <ul class="clearfix product_ys" v-else-if="item.display!==null&&item.display_type!=='product_checkbox' && item.type_name=='做袋工艺' ">
                    <li v-for="(u,i) in item.display_list" :key="i">{{u}}</li>
                  </ul>

                  <ul v-else-if="item.display_type=='product_checkbox' ">
                    <div class="fuxuan product_gy">
                      <label v-for="(u1,i) in item.display.split(',')" :key="i">
                        <input type="checkbox" class="check" :value="u1" />
                        <span>{{u1}}</span>
                      </label>
                    </div>
                  </ul>
                </dd>
              </dl>
              <div class="clearfix">
                <dl class="sy-prop clearfix" style="float:left;margin-right:30px;">
                  <dt>款 &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;数:</dt>
                  <dd :class="Cflag ? 'di' : ''">
                    <el-input-number v-model="num1" @change="handleChange" :min="1" :max="9999999" size="small"></el-input-number>
                  </dd>
                </dl>
                <dl class="sy-prop clearfix" v-if="f==true">
                  <dt>生产周期:</dt>
                  <dd :class="Cflag ? 'di' : ''" style="margin-top:5px">{{days}}天</dd>
                </dl>
              </div>
<div id="sy_Address" style="position:relative" v-show="sflag">
                <dl class="sy-prop clearfix addressBox" v-if="flag">
                  <dt>配 &nbsp;送&nbsp;至:</dt>
                 <dd>
                   <el-select v-show="!dialogVisible"  v-model="ruleForm.selectedValue"  name="address" id="addressSelect" style="margin-right:15px;width: 550px;" @change="Addressselect($event)" clearable filterable>
                      <el-option
                          v-for="(item, index) in addressList"
                          :key="index"
                          :id="item.provice_id"
                          :label="item.address ? item.address+item.shopping_name+item.query+item.shopping_name+item.shopping_phone+(item.ext_number?'转'+item.ext_number:''):' '"
                          :value="item.provice_id+'+'+item.id"
						 
                           ></el-option>
                  </el-select>

                    <el-button type="primary" size="small" id="addAddress" @click="showDialog()">点击使用老地址</el-button>
					<el-card inline v-show="dialogVisible" title="添加地址" style="width: 600px;padding: 0px;" >
					  <el-form  :model="ruleForm" :rules="rules" ref="ruleForm" label-width="70px"
					    class="demo-ruleForm">
					    <el-form-item label="自动识别">
					      <el-input type="textarea" style="width:330px" v-model="autoAdd" placeholder="输入淘宝单号,文件名,手机,姓名"></el-input>
					      <el-button style="margin-left:1px" type="success" @click="autoSpot">开始识别</el-button>
					    </el-form-item>
					    <el-form-item class="input_line"  label="姓名" prop="shopping_name">
					      <el-input style="width:150px" v-model="ruleForm.shopping_name" placeholder="姓名长度不超过25个字符"></el-input>
					    </el-form-item>
					    <el-form-item  class="input_line" label="电话" prop="shopping_phone">
					      <el-input style="width:150px" v-model="ruleForm.shopping_phone" placeholder="请输入收货人的手机号码"></el-input>
					    </el-form-item>
					    <el-form-item   class="input_line" label="分机号" prop="ext_number">
					      <el-input style="width:150px" v-model="ruleForm.ext_number" placeholder="请输入分机号"></el-input>
					    </el-form-item>
					    <v-distpicker class="address_picker" @selected="onSelected"></v-distpicker>
					    <el-form-item label="地址" prop="query">
					      <el-input style="width:350px" v-model="ruleForm.query" placeholder="请输入详细地址信息，如道路、门牌号、小区、楼栋号、单元等信息"></el-input>
					    </el-form-item>
					  </el-form>
					 <!-- <el-button @click="dialogVisible = false">取 消</el-button>
					  <el-button type="primary" @click="submitForm('ruleForm')">添加地址</el-button> -->
					</el-card>
                  </dd>
                </dl>
                <div style="margin-right:30px;position:absolute;top:5px;right:-14px;" class="regionBox">
                  <template v-if="Cflag">
                    <dl class="sy-prop clearfix" v-show="JSON.stringify(regionList)!=='{}'">
                      <dt>区 &nbsp; &nbsp; 域:</dt>
                      <dd :class="Cflag ? 'di' : ''" >{{regionList.express_template_name_level}}</dd>
                    </dl>
                  </template>
                  <dl class="sy-prop clearfix" v-else>
                    <dt>区 &nbsp; &nbsp; 域:</dt>
                    <dd>
                      <ul class="clearfix">
                        <template v-for="(item,index) in regionDataList.data">
                          <!-- <el-popover
                          placement="top-start"
                          title="地区"
                          width="200"
                          trigger="click"
                          content="1111"
                          ></el-popover>-->
                          <li :key="item.id" class="region_item" @click="getId(item.id)" :class="index==0 ? 'current' : ''">{{item.express_template_name_level}}</li>
                        </template>
                      </ul>
                    </dd>
                  </dl>
                </div>
              </div>
              <dl class="sy-prop clearfix footers">
                <dt>订单备注:</dt>
                <dd>
                  <input v-model="remarks" class="coustor" type="text" placeholder="备注最多十个字" maxlength="20" />
                </dd>
                <dt>物流方式:</dt>
                <dd >
                 <select name="express_id" id="expresslist" style="margin-right:15px" @change="Expressselect()">
                   <template v-if="expresslist!=='[]'">
                     <option :value="item.express_id" v-for="(item,index) in expresslist" :data-packnum='item.max_baoshu' :key="index" :id="item.express_id" :selected="item.max_baoshu>packnum && item.is_ok ? item.is_ok :false" :disabled="item.max_baoshu<packnum?true:false">
                       {{item.express_template_name}}</option>
                   </template>
                 </select>
                </dd>
                <dt></dt>
                <dd>
                  <a class="piliang2" v-show="productParams.product.product_file" target='_blank' :href="'https://yunshanyin.oss-cn-shenzhen.aliyuncs.com'+productParams.product.product_file+''">
                  模版下载
                  </a>
                </dd>
              </dl>
			  <dl class="sy-prop clearfix footers">
				  <form name="theform">
				    <input style="display:none" type="radio" name="myradio2" value="local_name" />
				    <input
				      style="display:none"
				      type="radio"
				      name="myradio2"
				      value="random_name"
				      checked="true"
				    />
				    <input
				      style="display:none"
				      type="text"
				      id="dirname2"
				      placeholder="如果不填，默认是上传到根目录"
				      :value="fileurl"
				      size="50"
				    />
				  </form>
			    <dt>文件上传:</dt>
			    <dd class="contaniner">
					<a
					  id="addOrderFile"
					  href="javascript:void(0);"
					  class="filebtn"
					>
					{{fileurl?'点击更换文件':'点击上传文件'}}
					</a>
					
					
					<input  type="hidden" name="fileurl" value=""/>
					   <div id="ossfile" class="ossfile"></div>
			    </dd>
			  
			  </dl>
              <div class="btn-group" v-show="sflag">
                <button class="xiadan" @click="addOrder()">
                  <img src="../../assets/detail/info_img/xiadan.png" /> 立即支付
                </button>
				<button class="addcar" @click="showShopCart()">
				  <img src="../../assets/detail/info_img/xiadan.png" /> 加入购物车
				</button>
                <div class="sy_sh">
                  <a v-if="KFQQ" target :href="'tencent://message/?uin='+KFQQ+'&Site=www.ysy.com:8888&Menu=yes'">
                    <img src="../../assets/images/qq.png" /> 客服QQ:{{KFQQ}}
                  </a>
                  <a v-if="SHQQ" target :href="'tencent://message/?uin='+SHQQ+'&Site=www.ysy.com:8888&Menu=yes'">
                    <img src="../../assets/images/qq.png" /> 售后QQ:{{SHQQ}}
                  </a>
                  <a class="small_ewm" href="javascript:void(0);" v-if="ERWEIMA!=''">
                    <div class="large_ewm">
                      <img :src="ERWEIMA" title="微信客服" style="width:200px" />
                    </div>
                    <img :src="ERWEIMA" title="微信客服" style="width:40px" />客服微信
                  </a>
                  <a class="piliang"  :href="'/#/batchorder?id='+this.selectProductInfo.data.product_id+''">
                    批量下单
                  </a>
                </div>
              </div>
            </div>
			<el-dialog :title="videoTitle" :visible="isVideoShow" width="70%" @close="closeDialog">
				  <video
					:src="videoUrl"
					controls
					autoplay
					class="video"
					width="100%"
				  ></video>
				</el-dialog>

            
          </div>
          <template v-if="sflag">
            <el-table class="table_detail" v-show="tabFlag && isdef" :data="tabData" border style="width: 100%; height: auto; ">
              <el-table-column prop="goods_price" label="商品价格(元)" width="180"></el-table-column>
              <el-table-column prop="craft_list" label="后工费用组成明细(元)" width="180">
                <template slot-scope="scope">
                  <p v-for="(item,key,index) in scope.row.craft_list" :key="index">{{key}} : {{item}}</p>
                </template>
              </el-table-column>
              <el-table-column prop="craft_price" label="后工费用总计(元)"></el-table-column>
              <el-table-column prop="packprice" label="包装费(元)"></el-table-column>
              <el-table-column prop="price_list" label="商品价格组成明细(元)">
                <template slot-scope="scope">
                  <p v-for="(item,key,index) in scope.row.price_list" :key="index">{{key}} : {{item}}</p>
                </template>
              </el-table-column>
              <el-table-column label="区域">{{regionList.express_template_name_level}}</el-table-column>
              <el-table-column prop="product_weight" label="重量（kg）"></el-table-column>
              <el-table-column prop="shipping_fee" label="快递费"></el-table-column>
              <el-table-column prop="price" label="价格总计(元)"></el-table-column>
            </el-table>
          </template>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import VDistpicker from 'v-distpicker'
  import {
    log
  } from 'util'
  var randomNum = 0
  export default {
    components: {
      VDistpicker
    },
    data() {
      return {
        // 包邮
		videoUrl:'',
		isVideoShow:false,
		videoTitle:'下单演示',
        free: 0,
        // 自动识别
        autoAdd: '',
        fmzhileiseledct: '55',
        nwzhileiseledct: '55',
        chicunlimit:{},
        chicunlimitdesc:'',
        chicun_min_l:20,
        chicun_min_w:20,
        chicun_max_l:1000,
        chicun_max_w:700,
        swiperOption: {
          slidesPerView: 5,
          spaceBetween: 30,
          pagination: {
            el: '.swiper-pagination',
            clickable: true
          }
        },
        baseUrl: '',
        randomId: 0,
        f: false,
        days: 0,
        packnum: 1,
        ruleForm: {
          // 省id
          address_id: '',
          provice_id: '',
          // 省市区id
          address: [],
          // 详细地址信息
          query: '',
          // 名字
          shopping_name: '',
		  ext_number: '',
          // 手机号码
          shopping_phone: '',
          token: window.localStorage.getItem('token'),
		  selectedValue:'',
        },
        rules: {
          address_id: [
            { required: true, message: '地址ID', trigger: 'change' }
          ],
          shopping_name: [{
              required: true,
              message: '请输入您的姓名',
              trigger: 'blur'
            },
            {
              min: 0,
              max: 25,
              message: '长度在 0 到 25 个字符',
              trigger: 'blur'
            }
          ],
          shopping_phone: [{
              required: true,
              message: '请输入手机号码',
              trigger: 'blur'
            },
            {
              min: 11,
              max: 11,
              message: '请核对手机号码',
              trigger: 'blur'
            }
          ],
          query: [{
              required: true,
              message: '请输入配送地址',
              trigger: 'blur'
            },
            {
              min: 1,
              max: 120,
              message: '详细地址长度需要在1-120个汉字或字符之间',
              trigger: 'blur'
            }
          ]
        },
        // 控制dialog
        dialogVisible: true,
        // 控制地址显示
        flag: false,
        // 商品id
        cateid: '',
        price: '',
        shipping_fee: 0,
        discount_price: 0,
        num1: 1,
        npnum: 4,
        tjnum: 0,
        wokou: 0,
        ckg: 1,
        ckgg: 1,
        addressValue: '',
        // 商品尺寸
        sizeChang: '',
        sizeKuan: '',
        chicun: '',
        // 款数
        kuanshu: 1,
        productName: '',
        factory_discount: 100,
        // 选中的商品参数
        selectProductInfo: {
          data: {
            product_id: '',
            region_id: '',
            express_id: '',
            externalhair_id: 2,
            is_shipping_fee: true,
            is_goods_desgin_fee: false,
            product: ''
          }
        },
        checkParams: {},
        productParams: {
          product: [],
          product_type: []
        },
        // 点击下单用户选中的商品信息
        orderInfo: {},
        // 地址信息
        addressList: [],
        expresslist: [],
        // 添加购物车传递的参数
        info: [],
        jinxuan: [],
        // 图片数组
        imglist: [],
        imgUrl: '',
        // 小图片数组
        ImgList: [],
        SHQQ: 0,
        KFQQ: 0,
        ERWEIMA: '',
        sflag: window.location.href.includes('detail'),
        Cflag: false,
        tabFlag: false,
        isdef: false,
        tabData: [],
        minNum: 0,
        // 区域数据
        regionList: {},
        // 全部区域数据
        regionDataList: [],
        // 提示
        proverMsg: '',
        hotImg: '',
        remarks: '',
        zhilei: [],
        inputstep: 2,
		user_money:0.00,
		fileurl:'',
	

      }
    },

    computed: {
      size() {
        if (this.sizeChang !== '' && this.sizeKuan !== '') {
          return this.sizeChang + '×' + this.sizeKuan
        }
        return '×'
      },
      demo() {
        if (this.checkParams['data[product][印刷数量][]']) {
          return this.checkParams['data[product][印刷数量][]'].indexOf(
              this.productParams.product.product_unit
            ) == -1
            ? this.checkParams['data[product][印刷数量][]'] +
            this.productParams.product.product_unit
            : this.checkParams['data[product][印刷数量][]']
        }
      }
    },

    methods: {
     
      // 会员信息
      async userInfo() {
        let param = new URLSearchParams()
        param.append('token', window.localStorage.getItem('token'))
        const {
          data: res
        } = await this.$http.post('api/mine/index', param)
        this.isdef = res.data.is_def
        this.free = res.data.free
        this.factory_discount = (res.data.factory_discount[0][this.selectProductInfo.data['product_id']] * res.data.factory_discount[0][0] / 100).toFixed(2)
		this.user_money =res.data.money;
      },
      async getzhilei() {
        let param = new URLSearchParams()
        param.append('token', window.localStorage.getItem('token'))
        const {
          data: res
        } = await this.$http.post('api/index/paperclass', param)
        this.zhilei = res.data
      },
      async getzhizhang(e) {
        let param = new URLSearchParams()

        param.append('token', window.localStorage.getItem('token'))
        param.append('id', $(e.target).val())
        const {
          data: res
        } = await this.$http.post('api/index/paperlist', param)
        if (res.code == 1) {
          let html = ''

          if (res.data.num > 10) {
            html += '<select id="' + $(e.target).attr('class') + 'selBox" data-v-206732c0=""  style="float: left; width: 100px; height: 27px;">'
            html += '<option data-v-206732c0="" value="0">请选择</option>'
            $.each(res.data.list, function(index, e) {
              html += '<option data-v-206732c0="" value="' + e + '">' + e + '</option>'
            })
            html += '</select>'
          } else {
            $.each(res.data.list, function(index, e) {
              html += '<li data-v-206732c0="">' + e + '</li>'
            })
          }

          $(e.target).parent().find('li').remove()
          $(e.target).parent().find('select').eq(1).remove()
          $(e.target).after(html)
        }
      },

      async getzhizhang2(val) {
        let param = new URLSearchParams()

        $('.fmzhilei').val(val)
        $('.nwzhilei').val(val)
        param.append('token', window.localStorage.getItem('token'))
        param.append('id', val)

        const {
          data: res
        } = await this.$http.post('api/index/paperlist', param)
        if (res.code == 1) {
          let html = ''
          let html2 = ''

          if (res.data.num > 10) {
            html += '<select id="fmzhileiselBox" data-v-206732c0=""  style="float: left; width: 100px; height: 27px;">'
            html2 += '<select id="nwzhileiselBox" data-v-206732c0=""  style="float: left; width: 100px; height: 27px;">'
            html += '<option data-v-206732c0="" value="0">请选择</option>'
            html2 += '<option data-v-206732c0="" value="0">请选择</option>'
            $.each(res.data.list, function(index, e) {
              html += '<option data-v-206732c0="" value="' + e + '">' + e + '</option>'
              html2 += '<option data-v-206732c0="" value="' + e + '">' + e + '</option>'
            })
            html += '</select>'
            html2 += '</select>'
          } else {
            $.each(res.data.list, function(index, e) {
              html += '<li data-v-206732c0="">' + e + '</li>'
              html2 += '<li data-v-206732c0="">' + e + '</li>'
            })
          }

          $('.fmzhilei').parent().find('li').remove()
          $('.nwzhilei').parent().find('li').remove()
          $('.fmzhilei').parent().find('select').eq(1).remove()
          $('.nwzhilei').parent().find('select').eq(1).remove()
          $('.fmzhilei').after(html)
          $('.nwzhilei').after(html2)
        }
		
		
      },
      // 自动识别
      async autoSpot() {
        const {
          data: res
        } = await this.$http.get(
          '/api/index/strtoaddress?str=' + this.autoAdd + '&token=' + window.localStorage.getItem('token')
        )
        if (res.code) {
          this.ruleForm.provice_id = res.data.province_id
          this.ruleForm.query = res.data.detail
          this.ruleForm.shopping_phone = res.data.mobile
          this.ruleForm.shopping_name = res.data.name
           this.ruleForm.ext_number = res.data.ext_number
          this.ruleForm.address =
            res.data.province_id +
            ',' +
            res.data.city_id +
            ',' +
            res.data.county_id
          $('.address_picker select:first option:first').text(
            res.data.province_name
          )
          this.selectProductInfo.data.region_id = res.data.province_id
          $('.address_picker select:eq(1) option:first').text(res.data.city_name)
          $('.address_picker select:last option:first').text(res.data.county_name)
          $('.address_picker select:first option:first')
        }
      },
      // 验证填写是否完全
      submitForm(formName) {
        if (this.ruleForm.address.length < 3) {
          this.$message('请选择完整的省市区', 'error')
          return
        }
        for (let i = 0; i < this.ruleForm.address.length; i++) {
          if (!this.ruleForm.address[i]) {
            this.$message('请选择完整的省市区', 'error')
            return
          }
        }
        this.selectProductInfo.data.region_id = this.ruleForm.provice_id
        console.log('222222222222222',this.ruleForm.provice_id);
         this.selectProductInfo.data.is_shipping_fee = true
        console.log(this.selectProductInfo.data.region_id)
        // this.ruleForm.address = this.ruleForm.address.join(',')
        this.$refs[formName].validate(async valid => {
          if (!valid) {

          } else {
            if (!this.ruleForm.provice_id || !this.ruleForm.address) {
              this.$message('请选择详细地区信息', '提示')
              return
            }
            if (typeof this.ruleForm.address !== 'string') {
              this.ruleForm.address = this.ruleForm.address.join(',')
            }

            let param = new URLSearchParams()
            for (let key in this.ruleForm) {
              param.append(key, this.ruleForm[key])
            }
            const {
              data: res
            } = await this.$http({
              method: 'post',
              url: 'api/address/addaddress',
              data: param
            })
            if (res.code == 1) {
              this.$confirm('添加地址信息成功！', '提示')
              this.getPrice()
              this.queryAddress(res.data)
              this.$refs[formName].resetFields()
              let timer
              timer = setInterval(() => {
              this.ruleForm.address_id=this.ruleForm.provice_id+'+'+res.data;
                 clearInterval(timer)
              }, 200)

              this.autoAdd = ''
              this.dialogVisible = false
              $('#addressSelect').change()
              console.log(1, 'zheli')
            } else {
              this.$message.error('添加地址失败，未知错误')
            }
          }
        })
      },
      onSelected(data) {
        this.ruleForm.address = []
        this.ruleForm.provice_id = ''
        this.ruleForm.provice_id = data.province.code
        for (let key in data) {
          this.ruleForm.address.push(data[key].code)
        }
      },
      showDialog() {
		  if(this.dialogVisible){
			  this.dialogVisible = false
			 $('#addressSelect').show()
			 $('#addAddress').find('span').empty().html('点击使用新地址')
		  }else{
			this.dialogVisible = true  
			$('#addressSelect').hide()
			$('#addAddress').find('span').empty().html('点击使用老地址')
			
		  }
		  
        
      },
	  closeDialog(){
		 this.isVideoShow = false  
	  },
	  payVideo(type) {
	    this.isVideoShow = true
		if(type == 'demo_video'){
			this.videoTitle='下单演示'
		}else{
			this.videoTitle='产品培训'
		}
		this.videoUrl = this.productParams.product[type]
	  },
      async queryParams() {
        this.SHQQ = 0
        this.KFQQ = 0
        this.ERWEIMA = ''
        $('.money').html('')
        $('.mone').html('')
        const {
          data: res
        } = await this.$http.get(
          '/api/Product/getProduct/product_id/' + this.cateid
        )
        this.userInfo()
        if (res.code != 1) {
          this.$message({
            type: 'error',
            message: '获取数据失败',
            duration: 2000
          })
        } else {
          this.chicunlimit=res.data.chicunlimit;
          if(res.data.product.chicun_min_l){
            this.chicun_min_l=res.data.product.chicun_min_l;
          }
          if(res.data.product.chicun_min_w){
            this.chicun_min_w=res.data.product.chicun_min_w;
          }
          if(res.data.product.chicun_max_l){
            this.chicun_max_l=res.data.product.chicun_max_l;
          }
          if(res.data.product.chicun_max_w){
            this.chicun_max_w=res.data.product.chicun_max_w;
          }
          this.chicunlimitdesc='提示：最小尺寸为:'+this.chicun_min_l+'X'+this.chicun_min_w+res.data.product.unit+
          ',最大尺寸为:'+this.chicun_max_l+'X'+this.chicun_max_w+res.data.product.unit;

          this.hotImg = res.data.product.product_hot_img
          this.cateid = res.data.product.product_id
          this.selectProductInfo.data.product_id = res.data.product.product_id
          this.imglist = res.data.imglist
          this.imgUrl = res.data.product.product_img
          this.minNum = res.data.product.minnum
          this.ImgList = []
          if (res.data.product.kfqq != null) {
            this.KFQQ = res.data.product.kfqq
          }
          if (res.data.product.shqq != null) {
            this.SHQQ = res.data.product.shqq
          }
          if (res.data.product.wx_img != null) {
            this.ERWEIMA = res.data.product.wx_img
          }

          if (JSON.stringify(res.data.imglist) != '[]') {
            for (let key in res.data.imglist) {
              this.ImgList.push(res.data.imglist[key])
            }
          }

          res.data.product.isprice
            ? (this.tabFlag = true)
            : (this.tabFlag = false)

          let sizeData = {}
          this.productParams.product_type = []
          this.productParams.product = res.data.product

          this.bixuan = this.productParams.product.product_must.split(',')
          let data = res.data.product_type
          for (let key in data) {
            // if (data[key].type_name == '产品尺寸') {
            //   sizeData = data[key]
            //   continue
            // }
            // if (data[key].type_name == '印刷数量') {
            //   this.productParams.product_type.push(sizeData)
            // }
            this.productParams.product_type.push(data[key])
          }
          document.title = this.productParams.product.product_name

          $('.productDetailImg').html(res.data.product.slogan)
          $('.productDetailImg p img').css('width', '100%')
		 this.$nextTick(() => {
		   // DOM已经更新
		 $('.sy-prop dd .product_zhonglei li:eq(0)').click()
		  $('.sy-prop dd .product_Count li:eq(0)').click()
		  
		 })
        }
      },
      async queryAddress(id = '') {
        let token = window.localStorage.getItem('token')
        if (token) {
          let param = new URLSearchParams()
          param.append('token', token)
          // param.append('id', id)
          const {
            data: res
          } = await this.$http({
            method: 'post',
            url: '/api/address/index',
            data: param
          })
          if (res.code == 1) {
            this.addressList = res.data.sort(this.compare('def'))
			this.ruleForm.selectedValue=  this.addressList[0].provice_id+'+'+this.addressList[0].id
			this.ruleForm.address_id=  this.addressList[0].provice_id+'+'+this.addressList[0].id
            console.log(this.addressList)
            var region_id = 0
            $.each(this.addressList, function(i, e) {
              if (id == e.id) {
                region_id = e.provice_id
              }
            })
             this.queryExpress('', region_id,id)
			 $('#addressSelect').change()
          } else {
            this.addressList = []
             this.queryExpress('', '')
          }
          if (this.sflag || window.sessionStorage.getItem('carid')) {
            if (this.addressList[0] !== undefined) {
              this.queryRegion(this.addressList[0].address_id[0])
            }
          }
        }
      },
      async queryExpress(id = '', region_id = '',address_id='') {
        let token = window.localStorage.getItem('token')
        if (token) {
          let param = new URLSearchParams()
          param.append('region_id', region_id)
          param.append('address_id', address_id)
          param.append('token', token)
          param.append('id', id)
          param.append('product_id', this.selectProductInfo.data.product_id)
          const {
            data: res
          } = await this.$http({
            method: 'post',
            url: '/api/address/expresslist',
            data: param
          })
          if (res.code == 1) {
            this.expresslist = res.data.sort(this.compare('is_ok'))
            if($('#expresslist option:selected').attr('disabled')){
              this.selectProductInfo.data.express_id = res.data[0].express_id
            }else{
               this.selectProductInfo.data.express_id =  res.data[0].express_id;
            }
            $('#expresslist').val(this.selectProductInfo.data.express_id)

          } else {
             // $('#expresslist').empty()
            this.selectProductInfo.data.express_id = ''
          }
          console.log(111,this.selectProductInfo.data.express_id)
          this.getPrice()
}
      },

      // 递归排序
      compare(property) {
        return function(a, b) {
          return b[property] - a[property]
        }
      },
      handleChange(value) {
        this.kuanshu = value
        this.checkParams['data[product][款数][]'] = value
        this.product(this)
      },
      handleChangenpnum(value) {
        this.npnum = value
        this.checkParams['data[product][内文P数][]'] = value
        this.product(this)
      },
      handleChangetjnum(value) {
        this.tjnum = value
        this.checkParams['data[product][烫金工艺][]'] = value
        this.product(this)
      },
      handleChangewokou(value) {
        this.wokou = value
        this.checkParams['data[product][封面握口][]'] = value
        this.product(this)
      },
      async xianzhi(zd, nw) {
        var pshuxianzhi = new Array('无线胶钉', '骑马钉', '锁线胶钉', '简精装', '对裱精装', '环装')
        		pshuxianzhi['无线胶钉'] = new Array(
        				'128g铜版', '157g铜版', '200g铜版', '250g铜版', '300g铜版', '128g哑粉', '157g哑粉', '200g哑粉', '250g哑粉', '300g哑粉',
        				'70g双胶', '80g双胶', '100g双胶', '120g双胶',
        				'白滑影250g', '朱滑影250g', '白布纹250g', '针孔超白300g', '针孔米黄300g', '蛋壳纹尼桑300g', '竹丝纹300g', '美影超白300g', '美影米黄300g', '丽芙雅典超白300g', '伯爵纸300g', '布纹米黄300g', '新美感315g', '新美感米白145g', '新美感米白250g', '新美感米白180g', '白卡250g', '牛皮纸250g',
        				'80g道林',
        				'230g白色皮纹纸', '230g米黄皮纹纸', '230g大红皮纹纸', '230g浅蓝皮纹纸', '230g深蓝皮纹纸', '230g浅绿皮纹纸', '230g深绿皮纹纸'
        		)
        		pshuxianzhi['骑马钉'] = new Array(
        				'128g铜版', '157g铜版', '200g铜版', '250g铜版', '300g铜版', '128g哑粉', '157g哑粉', '200g哑粉', '250g哑粉', '300g哑粉',
        				'70g双胶', '80g双胶', '100g双胶', '120g双胶',
        				'白滑影250g', '朱滑影250g', '白布纹250g', '针孔超白300g', '针孔米黄300g', '蛋壳纹尼桑300g', '竹丝纹300g', '美影超白300g', '美影米黄300g', '丽芙雅典超白300g', '伯爵纸300g', '布纹米黄300g', '新美感315g', '新美感米白145g', '新美感米白250g', '新美感米白180g', '白卡250g', '牛皮纸250g',
        				'80g道林',
        				'230g白色皮纹纸', '230g米黄皮纹纸', '230g大红皮纹纸', '230g浅蓝皮纹纸', '230g深蓝皮纹纸', '230g浅绿皮纹纸', '230g深绿皮纹纸'
        		)
        		pshuxianzhi['锁线胶钉'] = new Array(
        				'128g铜版', '157g铜版', '200g铜版', '250g铜版', '300g铜版', '128g哑粉', '157g哑粉', '200g哑粉', '250g哑粉', '300g哑粉',
        				'70g双胶', '80g双胶', '100g双胶', '120g双胶',
        				'白滑影250g', '朱滑影250g', '白布纹250g', '针孔超白300g', '针孔米黄300g', '蛋壳纹尼桑300g', '竹丝纹300g', '美影超白300g', '美影米黄300g', '丽芙雅典超白300g', '伯爵纸300g', '布纹米黄300g', '新美感315g', '新美感米白145g', '新美感米白250g', '新美感米白180g', '白卡250g', '牛皮纸250g',
        				'80g道林',
        				'230g白色皮纹纸', '230g米黄皮纹纸', '230g大红皮纹纸', '230g浅蓝皮纹纸', '230g深蓝皮纹纸', '230g浅绿皮纹纸', '230g深绿皮纹纸'
        		)
        		pshuxianzhi['简精装'] = new Array(
        				'128g铜版', '157g铜版', '200g铜版', '250g铜版', '300g铜版', '128g哑粉', '157g哑粉', '200g哑粉', '250g哑粉', '300g哑粉',
        				'70g双胶', '80g双胶', '100g双胶', '120g双胶',
        				'白滑影250g', '朱滑影250g', '白布纹250g', '针孔超白300g', '针孔米黄300g', '蛋壳纹尼桑300g', '竹丝纹300g', '美影超白300g', '美影米黄300g', '丽芙雅典超白300g', '伯爵纸300g', '布纹米黄300g', '新美感315g', '新美感米白145g', '新美感米白250g', '新美感米白180g', '白卡250g', '牛皮纸250g',
        				'80g道林',
        				'230g白色皮纹纸', '230g米黄皮纹纸', '230g大红皮纹纸', '230g浅蓝皮纹纸', '230g深蓝皮纹纸', '230g浅绿皮纹纸', '230g深绿皮纹纸'
        		)
        		pshuxianzhi['对裱精装'] = new Array(
        				'128g铜版', '157g铜版', '200g铜版', '250g铜版', '300g铜版', '128g哑粉', '157g哑粉', '200g哑粉', '250g哑粉', '300g哑粉',
        				'70g双胶', '80g双胶', '100g双胶', '120g双胶',
        				'白滑影250g', '朱滑影250g', '白布纹250g', '针孔超白300g', '针孔米黄300g', '蛋壳纹尼桑300g', '竹丝纹300g', '美影超白300g', '美影米黄300g', '丽芙雅典超白300g', '伯爵纸300g', '布纹米黄300g', '新美感315g', '新美感米白145g', '新美感米白250g', '新美感米白180g', '白卡250g', '牛皮纸250g',
        				'80g道林',
        				'230g白色皮纹纸', '230g米黄皮纹纸', '230g大红皮纹纸', '230g浅蓝皮纹纸', '230g深蓝皮纹纸', '230g浅绿皮纹纸', '230g深绿皮纹纸'
        		)
        		pshuxianzhi['环装'] = new Array(
        				'128g铜版', '157g铜版', '200g铜版', '250g铜版', '300g铜版', '128g哑粉', '157g哑粉', '200g哑粉', '250g哑粉', '300g哑粉',
        				'70g双胶', '80g双胶', '100g双胶', '120g双胶',
        				'白滑影250g', '朱滑影250g', '白布纹250g', '针孔超白300g', '针孔米黄300g', '蛋壳纹尼桑300g', '竹丝纹300g', '美影超白300g', '美影米黄300g', '丽芙雅典超白300g', '伯爵纸300g', '布纹米黄300g', '新美感315g', '新美感米白145g', '新美感米白250g', '新美感米白180g', '白卡250g', '牛皮纸250g',
        				'80g道林',
        				'230g白色皮纹纸', '230g米黄皮纹纸', '230g大红皮纹纸', '230g浅蓝皮纹纸', '230g深蓝皮纹纸', '230g浅绿皮纹纸', '230g深绿皮纹纸'
        		)
        		pshuxianzhi['无线胶钉']['105g铜版'] = new Array(48, 426)
        		pshuxianzhi['无线胶钉']['128g铜版'] = new Array(48, 350)
        		pshuxianzhi['无线胶钉']['157g铜版'] = new Array(36, 280)
        		pshuxianzhi['无线胶钉']['200g铜版'] = new Array(35, 0)
        		pshuxianzhi['无线胶钉']['250g铜版'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['300g铜版'] = new Array(0, 0)

        		pshuxianzhi['无线胶钉']['105g哑粉'] = new Array(48, 426)
        		pshuxianzhi['无线胶钉']['128g哑粉'] = new Array(48, 350)
        		pshuxianzhi['无线胶钉']['157g哑粉'] = new Array(36, 280)
        		pshuxianzhi['无线胶钉']['200g哑粉'] = new Array(35, 0)
        		pshuxianzhi['无线胶钉']['250g哑粉'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['300g哑粉'] = new Array(0, 0)

        		pshuxianzhi['无线胶钉']['70g双胶'] = new Array(48, 500)
        		pshuxianzhi['无线胶钉']['80g双胶'] = new Array(48, 450)
        		pshuxianzhi['无线胶钉']['100g双胶'] = new Array(32, 400)
        		pshuxianzhi['无线胶钉']['120g双胶'] = new Array(32, 400)
        		pshuxianzhi['无线胶钉']['80g道林'] = new Array(32, 480)

        		pshuxianzhi['无线胶钉']['250g白滑影'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['250g朱滑影'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['250g白布纹'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['300g针孔超白'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['300g针孔米黄'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['300g蛋壳纹尼桑'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['300g竹丝纹'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['300g美影超白'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['300g美影米黄'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['300g丽芙雅典超白'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['300g伯爵纸'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['300g布纹米黄'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['315g新美感'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['145g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['250g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['180g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['无线胶钉']['250g白卡'] = new Array(16, 0)
        		pshuxianzhi['无线胶钉']['250g牛皮纸'] = new Array(0, 0)

        		pshuxianzhi['骑马钉']['105g铜版'] = new Array(4, 46)
        		pshuxianzhi['骑马钉']['128g铜版'] = new Array(4, 38)
        		pshuxianzhi['骑马钉']['157g铜版'] = new Array(4, 32)
        		pshuxianzhi['骑马钉']['200g铜版'] = new Array(4, 24)
        		pshuxianzhi['骑马钉']['250g铜版'] = new Array(4, 0)
        		pshuxianzhi['骑马钉']['300g铜版'] = new Array(4, 12)

        		pshuxianzhi['骑马钉']['105g哑粉'] = new Array(4, 46)
        		pshuxianzhi['骑马钉']['128g哑粉'] = new Array(4, 38)
        		pshuxianzhi['骑马钉']['157g哑粉'] = new Array(4, 30)
        		pshuxianzhi['骑马钉']['200g哑粉'] = new Array(4, 24)
        		pshuxianzhi['骑马钉']['250g哑粉'] = new Array(4, 20)
        		pshuxianzhi['骑马钉']['300g哑粉'] = new Array(4, 12)

        		pshuxianzhi['骑马钉']['70g双胶'] = new Array(4, 52)
        		pshuxianzhi['骑马钉']['80g双胶'] = new Array(4, 44)
        		pshuxianzhi['骑马钉']['100g双胶'] = new Array(4, 36)
        		pshuxianzhi['骑马钉']['120g双胶'] = new Array(4, 28)
        		pshuxianzhi['骑马钉']['80g道林'] = new Array(4, 44)

        		pshuxianzhi['骑马钉']['250g白滑影'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['250g朱滑影'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['250g白布纹'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['300g针孔超白'] = new Array(4, 12)
        		pshuxianzhi['骑马钉']['300g针孔米黄'] = new Array(4, 12)
        		pshuxianzhi['骑马钉']['300g蛋壳纹尼桑'] = new Array(4, 12)
        		pshuxianzhi['骑马钉']['300g竹丝纹'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['300g美影超白'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['300g美影米黄'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['300g丽芙雅典超白'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['300g伯爵纸'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['300g布纹米黄'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['315g新美感'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['145g新美感米白'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['250g新美感米白'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['180g新美感米白'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['250g白卡'] = new Array(4, 16)
        		pshuxianzhi['骑马钉']['250g牛皮纸'] = new Array(4, 16)

        		pshuxianzhi['锁线胶钉']['105g铜版'] = new Array(48, 426)
        		pshuxianzhi['锁线胶钉']['128g铜版'] = new Array(48, 350)
        		pshuxianzhi['锁线胶钉']['157g铜版'] = new Array(36, 280)
        		pshuxianzhi['锁线胶钉']['200g铜版'] = new Array(35, 0)
        		pshuxianzhi['锁线胶钉']['250g铜版'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['300g铜版'] = new Array(0, 0)

        		pshuxianzhi['锁线胶钉']['105g哑粉'] = new Array(48, 426)
        		pshuxianzhi['锁线胶钉']['128g哑粉'] = new Array(48, 350)
        		pshuxianzhi['锁线胶钉']['157g哑粉'] = new Array(36, 280)
        		pshuxianzhi['锁线胶钉']['200g哑粉'] = new Array(35, 0)
        		pshuxianzhi['锁线胶钉']['250g哑粉'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['300g哑粉'] = new Array(0, 0)

        		pshuxianzhi['锁线胶钉']['70g双胶'] = new Array(48, 500)
        		pshuxianzhi['锁线胶钉']['80g双胶'] = new Array(48, 450)
        		pshuxianzhi['锁线胶钉']['100g双胶'] = new Array(32, 400)
        		pshuxianzhi['锁线胶钉']['120g双胶'] = new Array(32, 400)
        		pshuxianzhi['锁线胶钉']['80g道林'] = new Array(32, 480)

        		pshuxianzhi['锁线胶钉']['250g白滑影'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['250g朱滑影'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['250g白布纹'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['300g针孔超白'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['300g针孔米黄'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['300g蛋壳纹尼桑'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['300g竹丝纹'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['300g美影超白'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['300g美影米黄'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['300g丽芙雅典超白'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['300g伯爵纸'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['300g布纹米黄'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['315g新美感'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['145g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['250g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['180g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['锁线胶钉']['250g白卡'] = new Array(16, 0)
        		pshuxianzhi['锁线胶钉']['250g牛皮纸'] = new Array(0, 0)

        		pshuxianzhi['简精装']['105g铜版'] = new Array(28, 426)
        		pshuxianzhi['简精装']['128g铜版'] = new Array(22, 350)
        		pshuxianzhi['简精装']['157g铜版'] = new Array(18, 280)
        		pshuxianzhi['简精装']['200g铜版'] = new Array(15, 0)
        		pshuxianzhi['简精装']['250g铜版'] = new Array(0, 0)
        		pshuxianzhi['简精装']['300g铜版'] = new Array(0, 0)

        		pshuxianzhi['简精装']['105g哑粉'] = new Array(28, 426)
        		pshuxianzhi['简精装']['128g哑粉'] = new Array(22, 350)
        		pshuxianzhi['简精装']['157g哑粉'] = new Array(18, 280)
        		pshuxianzhi['简精装']['200g哑粉'] = new Array(15, 0)
        		pshuxianzhi['简精装']['250g哑粉'] = new Array(0, 0)
        		pshuxianzhi['简精装']['300g哑粉'] = new Array(0, 0)

        		pshuxianzhi['简精装']['70g双胶'] = new Array(48, 500)
        		pshuxianzhi['简精装']['80g双胶'] = new Array(48, 450)
        		pshuxianzhi['简精装']['100g双胶'] = new Array(32, 400)
        		pshuxianzhi['简精装']['120g双胶'] = new Array(32, 400)
        		pshuxianzhi['简精装']['80g道林'] = new Array(32, 480)

        		pshuxianzhi['简精装']['250g白滑影'] = new Array(16, 0)
        		pshuxianzhi['简精装']['250g朱滑影'] = new Array(16, 0)
        		pshuxianzhi['简精装']['250g白布纹'] = new Array(16, 0)
        		pshuxianzhi['简精装']['300g针孔超白'] = new Array(16, 0)
        		pshuxianzhi['简精装']['300g针孔米黄'] = new Array(16, 0)
        		pshuxianzhi['简精装']['300g蛋壳纹尼桑'] = new Array(16, 0)
        		pshuxianzhi['简精装']['300g竹丝纹'] = new Array(16, 0)
        		pshuxianzhi['简精装']['300g美影超白'] = new Array(0, 0)
        		pshuxianzhi['简精装']['300g美影米黄'] = new Array(0, 0)
        		pshuxianzhi['简精装']['300g丽芙雅典超白'] = new Array(0, 0)
        		pshuxianzhi['简精装']['300g伯爵纸'] = new Array(0, 0)
        		pshuxianzhi['简精装']['300g布纹米黄'] = new Array(0, 0)
        		pshuxianzhi['简精装']['315g新美感'] = new Array(0, 0)
        		pshuxianzhi['简精装']['145g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['简精装']['250g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['简精装']['180g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['简精装']['250g白卡'] = new Array(16, 0)
        		pshuxianzhi['简精装']['250g牛皮纸'] = new Array(0, 0)

        		pshuxianzhi['对裱精装']['105g铜版'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['128g铜版'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['157g铜版'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['200g铜版'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['250g铜版'] = new Array(4, 0)
        		pshuxianzhi['对裱精装']['300g铜版'] = new Array(4, 116)

        		pshuxianzhi['对裱精装']['105g哑粉'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['128g哑粉'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['157g哑粉'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['200g哑粉'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['250g哑粉'] = new Array(4, 0)
        		pshuxianzhi['对裱精装']['300g哑粉'] = new Array(4, 116)

        		pshuxianzhi['对裱精装']['70g双胶'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['80g双胶'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['100g双胶'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['120g双胶'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['80g道林'] = new Array(0, 0)

        		pshuxianzhi['对裱精装']['250g白滑影'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['250g朱滑影'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['250g白布纹'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g针孔超白'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g针孔米黄'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g蛋壳纹尼桑'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g竹丝纹'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g美影超白'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g美影米黄'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g丽芙雅典超白'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g伯爵纸'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['300g布纹米黄'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['315g新美感'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['145g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['250g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['180g新美感米白'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['250g白卡'] = new Array(0, 0)
        		pshuxianzhi['对裱精装']['250g牛皮纸'] = new Array(0, 0)
            if (nw == 0) {
             this.inputstep = 2
              $('input[name="npnum"]').attr('aria-valuemin', 2)
              $('input[name="npnum"]').attr('aria-valuemax', 10000)
            } else {
             if (zd && nw) {
               if (zd == '骑马钉') {
                 this.inputstep = 4
               } else {
                 this.inputstep = 2
               }
             			var minnum; var maxnum = ''
             			$('.tips').text('')
             			if (pshuxianzhi[zd] && pshuxianzhi[zd][nw]) {
             				if (pshuxianzhi[zd][nw][0] == '0' || pshuxianzhi[zd][nw][0] == '无') {
             					minnum = 2
             				} else {
             					minnum = pshuxianzhi[zd][nw][0]
             				}
             				if (pshuxianzhi[zd][nw][1] == '0' || pshuxianzhi[zd][nw][1] == '无') {
             					maxnum = 9999
             				} else {
             					maxnum = pshuxianzhi[zd][nw][1]
             				}

             				$('input[name="npnum"]').attr('aria-valuemin', minnum)
             				$('input[name="npnum"]').attr('aria-valuemax', maxnum)
             				if ($('input[name="npnum"]').val() > maxnum) {
             					this.npnum = maxnum
             					this.checkParams['data[product][内文P数][]'] = maxnum
             					$('.tips').text(zd + nw + '最大' + maxnum + 'P')
             				}
             				if ($('input[name="npnum"]').val() < minnum) {
             					this.npnum = minnum
             					this.checkParams['data[product][内文P数][]'] = minnum
             					$('.tips').text(zd + nw + '最小' + minnum + 'P')
             				}
             			} else {
             				$('input[name="npnum"]').attr('aria-valuemin', 2)
             				$('input[name="npnum"]').attr('aria-valuemax', 10000)
             			}
             		} else {
             			$('input[name="npnum"]').attr('aria-valuemin', 2)
             			$('input[name="npnum"]').attr('aria-valuemax', 10000)
             		}
            }
      },
      // 获取价格函数
      async getPrice() {
      if (this.selectProductInfo.data.product_id == 95 || this.selectProductInfo.data.product_id == 5) {
         this.xianzhi(this.checkParams['data[product][装钉工艺][]'], this.checkParams['data[product][内文用纸][]'])
       }
        for (let i = 0; i < this.bixuan.length; i++) {
          if (
            this.checkParams[
              'data[product]' + '[' + this.bixuan[i] + ']' + '[]'
            ] == undefined
          ) {
            console.log(this.bixuan)
            this.productName = ''
            this.price = ''
            this.f = false
             return
          }
        }
        for (let keyt in this.checkParams) {
          let kV = this.checkParams[keyt]
          if (kV == '' || kV == 'X' || kV == 0) {
            let m = keyt.replace(/[^\u4e00-\u9fa5]/gi, '')
            this.price = ''
            this.productName = ''
            this.f = false
            return
          }
        }
        let param = new URLSearchParams()
        let optionCheck = $('#expresslist option:selected').attr('value')
        //this.selectProductInfo.data.express_id = optionCheck
        param.append('data[product_id]', this.selectProductInfo.data.product_id)
        param.append('data[region_id]', this.selectProductInfo.data.region_id)
        param.append('data[express_id]', this.selectProductInfo.data.express_id)
        param.append(
          'data[externalhair_id]',
          this.selectProductInfo.data.externalhair_id
        )
        param.append(
          'data[is_shipping_fee]',
          this.selectProductInfo.data.is_shipping_fee
        )
        param.append(
          'data[is_goods_desgin_fee]',
          this.selectProductInfo.data.is_goods_desgin_fee
        )
        // 对属性排序
        let nameArr = []
        let demo = this.productParams.product_type

        let newOb = {}
        for (let i = 0; i < demo.length; i++) {
          nameArr.push(demo[i].type_name)
        }

        for (let j = 0; j < nameArr.length; j++) {
          for (let keyss in this.checkParams) {
            if (keyss.indexOf(nameArr[j]) != -1) {
              newOb[keyss] = this.checkParams[keyss]
            }
          }
        }
        newOb['data[product][款数][]'] = this.checkParams['data[product][款数][]']

        if (this.checkParams['data[product][内文P数][]']) {
           newOb['data[product][内文P数][]'] = this.checkParams['data[product][内文P数][]']
        }
       if (this.checkParams['data[product][烫金工艺][]']) {
           newOb['data[product][烫金工艺][]'] = this.checkParams['data[product][烫金工艺][]']
       }


console.log(demo,nameArr,newOb,'123456')
        for (let key in newOb) {
          if (Array.isArray(newOb[key])) {
            for (let ii = 0; ii < newOb[key].length; ii++) {
              param.append(key, newOb[key][ii])
            }
            continue
          }

          param.append(key, newOb[key])
        }
        let token = window.localStorage.getItem('token')
        if (!token) {
          this.$confirm('您需要先登陆才能看到价格，是否立即去登陆?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              this.$router.push('/login')
            })
            .catch(() => {})
          return
        }

        param.append('token', window.localStorage.getItem('token'))

        try {
          const {
            data: res
          } = await this.$http({
            method: 'post',
            url: '/api/Product/productAccounting',
            headers: {
              'Content-type': 'application/x-www-form-urlencoded;charset=UTF-8'
            },
            data: param
          })

          var product_id = this.selectProductInfo.data.product_id
		  $('input[name="fileurl"]').val('')
		   $('.ossfile').empty().html('')
		  

          if (res.data !== null && res.data.code != -1) {
            if (product_id == 79 || product_id == 4) {
              var ii = 0
              var spec_key_name = res.data.price[0].spec_key_name
              var aa = res.data.price[0].rchicun.split('mm')
              //  var bb = aa[0].rchicun.split('+')
              var bb = aa[0]
              var cc = bb.split('+')

              var rw = cc[0]
              var rh = cc[1]

              if ((rw < 300 && rh < 450) || (rw < 450 && rh < 300) || (rw < 300 || rh < 300) || (rw < 450 && rh < 450)) {
                ii = 1
              }
              // 单粘口纸张展开尺寸任意方向大于700*1020
              if (spec_key_name.indexOf('单粘') >= 0) {
                if ((rw > 700 && rh > 1020) || (rw > 1020 && rh > 700) || (rw > 1020 || rh > 1020) || (rw > 700 && rh >
                    700)) {
                  ii = 1
                }
              }

              // 双粘口单片展开尺寸大于700*510mm
              if (spec_key_name.indexOf('内容一样双粘') >= 0 || spec_key_name.indexOf('内容不一样双粘') >= 0) {
                var srw = rw / 2
                var srh = rh
                if ((srw > 700 && srh > 510) || (srw > 510 && srh > 700) || (srw > 700 || srh > 700) || (srw > 510 &&
                    srh > 510)) {
                  ii = 1
                }
              }

              if (ii == 1) {
                $('.kgh').text('请联系客服询价')
                $('.money').text('请联系客服询价')

                $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                  $(this).children('dd').children('ul').find('li').addClass('disabled syc')
                })
                return false
              } else {
                this.ckgg = 1
              }

              // if((rw+rh)*2>=1020){
              //   if( !$('.product_ys li').eq(2).hasClass('current')){
              //       $('.product_ys li').eq(1).addClass('current');
              //   }
              //   // disabled syc
              //        $('.product_ys li').eq(0).removeClass('current');
              //       $('.product_ys li').eq(0).addClass('disabled');
              //       $('.product_ys li').eq(0).addClass('syc');

              //     //   return false;
              // }
            }

            this.tabData = res.data.price
            $('.mone').text('')
            this.f = true

            if (this.ckg == 1 && this.ckgg == 1) {
              $('.kgh').text('')
              this.price = parseFloat(res.data.price[0].price)
              this.shipping_fee = parseFloat(res.data.price[0].shipping_fee)
              this.discount_price = (parseFloat(((this.price - this.shipping_fee) * this.factory_discount / 100).toFixed(2)) + parseFloat(this.shipping_fee)).toFixed(2)
              $('.money').text('￥' + this.price + '元')
            } else {
              this.price = ''
              $('.kgh').text('请联系客服询价')
              this.$nextTick(_ => {
                $('.mone').text('请联系客服询价')
              })
            }
            this.productName = res.data.price[0].spec_key_name

            let key = [...param.keys()]
            let val = [...param.values()]
            for (let i = 0; i < key.length; i++) {
              this.orderInfo[key[i]] = val[i]
            }
            this.info = res.data.price[0]
            this.days = res.data.price[0].days
            this.packnum = parseFloat(res.data.price[0].packnum) * parseFloat(this.kuanshu)


            var expressname = $('#expresslist > #' + this.selectProductInfo.data.express_id).text().trim()
            var max_baoshu = $('#expresslist > #' + this.selectProductInfo.data.express_id).data('packnum')
            console.log(11111111111111111111,max_baoshu, expressname, this.packnum,this.selectProductInfo.data.express_id)
            $('.price').find('strong').show()
            if (this.packnum > max_baoshu  && expressname != '请选择') {
               this.price = '选择的产品超出' + expressname + '最大揽收包数，请重新选择快递！'
               this.discount_price = 0
            $('.kgh').text('选择的产品超出' + expressname + '最大揽收包数，请重新选择快递！')
                $('.money').text('选择的产品超出' + expressname + '最大揽收包数，请重新选择快递！')
                $('.price').find('strong').hide()
            }
          } else if (res.data.code == -1) {
            this.price = ''
            this.productName = res.data.msg
            this.$nextTick(_ => {
              $('.mone').text(res.data.msg)
            })
          } else {
            this.$message({
              type: 'error',
              message: res.msg,
              duration: 2000
            })
            this.productName = ''
            this.price = ''
            this.f = false
          }
        } catch (error) {
          this.productName = ''
          this.price = ''
        }
      },
      async showShopCart() {
        $('#chang').change()


        if (this.selectProductInfo.data.express_id == 0) {
          this.$confirm('请选择物流方式', '提示')
          return
        }
		if($('input[name="fileurl"]').val().length<10){
			this.$confirm('请上传文件订单文件', '提示')
			return false 
		}
        window.fXD = false
        let token = window.localStorage.getItem('token')
        if (!token) {
          this.$confirm('您需要先登陆才能下单，是否立即去登陆?', '提示', {
              confirmButtonText: '确定',
              cancelButtonText: '取消',
              type: 'warning'
            })
            .then(() => {
              this.$router.push('/login')
            })
            .catch(() => {})
          window.fXD = false
          return
        }
        let address_id = this.ruleForm.address_id.split('+')[1]
        console.log('这里的地址：',address_id);
        if (!this.price || $('.money').text() == '' || $('.money').text() == '请联系客服询价') {
          window.fXD = false
          return alert('产品规格不全,不能下单！！')
        }
        if (isNaN(this.price)) {
          window.fXD = false
          return alert(this.price)
        }
        if (window.location.href.includes('detail')) {
          if (!address_id) {
            window.fXD = false
            $('#addAddress').click()
            return
          }
        }

        if (JSON.stringify(this.orderInfo) !== '{}') {
          let param = new URLSearchParams()
          for (let key in this.orderInfo) {
            param.append(key, this.orderInfo[key])
          }
          let title = $('.select_product_info').text()
          title = title.replace(/\s+/g, '')
          if (!window.location.href.includes('detail')) {
            if (window.sessionStorage.getItem('carid')) {
              param.append('carid', window.sessionStorage.getItem('carid'))
              param.append('cartype', 2)
            } else {
              this.$confirm('下单失败，未知错误！', '提示')
              return
            }
            if (window.sessionStorage.getItem('carno') != 1) {
              param.append('address_id', address_id)
            }
          } else {
            param.append('address_id', address_id)
          }
          if(address_id){
            param.append('address_id', address_id)

          }
		  if(this.dialogVisible == true){
		  		 console.log('12121212address',this.ruleForm.address)
		  	if(!this.ruleForm.shopping_name){
		  		 return alert('请填写收货人')
		  	}
		  	if(!this.ruleForm.shopping_phone){
		  		 return alert('请填写收货人电话')
		  	}
		  		
		  		if(typeof this.ruleForm.address === 'string'){
		  			let addressarr =this.ruleForm.address.split(',')
		  			if(!addressarr[0] || !addressarr[1] || !addressarr[2]){
		  				 return alert('请填写收货人省市区')
		  			}
		  			param.append('address',this.ruleForm.address)
		  		}else{
		  			if(!this.ruleForm.address[0] || !this.ruleForm.address[1] || !this.ruleForm.address[2]){
		  				 return alert('请填写收货人省市区')
		  			}
		  			param.append('address',this.ruleForm.address.join(','))
		  		}
		  	
		  	if(!this.ruleForm.query){
		  		 return alert('请填写收货人详细地址')
		  	}
		  	
		  	param.append('shopping_name', this.ruleForm.shopping_name)
		  	param.append('shopping_phone',this.ruleForm.shopping_phone)
		  	param.append('ext_number',this.ruleForm.ext_number)
		  	param.append('query',this.ruleForm.query)
		  	
		  }else{
		  		  
		  		  
		  	
		  }

          param.append('express_id', this.selectProductInfo.data.express_id)
          param.append('price', this.price)
          param.append('title', title)
          param.append('number', this.checkParams['data[product][印刷数量][]'])
          param.append('kuanshu', this.info.kuanshu)
          param.append('craft_price', this.info.craft_price)
          param.append('shipping_fee', this.info.shipping_fee)
          param.append('product_weight', this.info.product_weight)
          param.append('spec_key_name', this.info.spec_key_name)
          param.append('goods_price', this.info.goods_price)
          param.append('packprice', this.info.packprice)
          param.append('mianshu', this.packnum)
          param.append('remarks', this.remarks)
		  param.append('filename', $('input[name="fileurl"]').val())
		   this.fileurl =$('input[name="fileurl"]').val();
		  let fileurlarr =this.fileurl .split('/')
		   param.append('file', fileurlarr[fileurlarr.length-1])

          const {
            data: res
          } = await this.$http({
            method: 'post',
            url: '/api/car/addcar',
            data: param
          })
          if (res.code) {
			  $('input[name="fileurl"]').val('')
			   $('.ossfile').empty().html('')
			   this.ruleForm.shopping_name='';
			   this.ruleForm.shopping_phone='';
			   this.ruleForm.ext_number='';
			   this.ruleForm.address='';
			   this.ruleForm.query='';
            if (window.sessionStorage.getItem('carid')) {
              window.sessionStorage.setItem('ok', 'ok')
              window.sessionStorage.removeItem('carid')
            }
          }
          window.fXD = true
          if (res.code != 1) {
            this.$confirm(res.msg, '提示', {
              confirmButtonText: '确定',
              callback: action => {
                this.$message({
                  type: 'error'
                })
              }
            })
          }
        } else {
          alert('请先选择商品各个属性')
          window.fXD = false
        }
      },
	  //直接下单
	  async addOrder() {
	    $('#chang').change()
	  
	  
	  
	    if (this.selectProductInfo.data.express_id == 0) {
	      this.$confirm('请选择物流方式', '提示')
	      return
	    }
		if($('input[name="fileurl"]').val().length<10){
			this.$confirm('请上传文件订单文件', '提示')
			return false 
		}
	    window.fXD = false
	    let token = window.localStorage.getItem('token')
	    if (!token) {
	      this.$confirm('您需要先登陆才能下单，是否立即去登陆?', '提示', {
	          confirmButtonText: '确定',
	          cancelButtonText: '取消',
	          type: 'warning'
	        })
	        .then(() => {
	          this.$router.push('/login')
	        })
	        .catch(() => {})
	      window.fXD = false
	      return
	    }
	    let address_id = this.ruleForm.address_id.split('+')[1]
	    console.log('这里的地址：',address_id,this.ruleForm.shopping_name);
		
	    if (!this.price || $('.money').text() == '' || $('.money').text() == '请联系客服询价') {
	      window.fXD = false
	      return alert('产品规格不全,不能下单！！')
	    }
	    if (isNaN(this.price)) {
	      window.fXD = false
	      return alert(this.price)
	    }
		 if(this.dialogVisible == false){
			 
			 if (window.location.href.includes('detail')) {
			   if (!address_id) {
			     window.fXD = false
			     $('#addAddress').click()
			     return
			   }
			 }
			 
			 
			 }
			 
	    
	  
	    if (JSON.stringify(this.orderInfo) !== '{}') {
	      let param = new URLSearchParams()
	      for (let key in this.orderInfo) {
	        param.append(key, this.orderInfo[key])
	      }
	      let title = $('.select_product_info').text()
	      title = title.replace(/\s+/g, '')
	      if (!window.location.href.includes('detail')) {
	        if (window.sessionStorage.getItem('carid')) {
	          param.append('carid', window.sessionStorage.getItem('carid'))
	          param.append('cartype', 2)
	        } else {
	          this.$confirm('下单失败，未知错误！', '提示')
	          return
	        }
	        if (window.sessionStorage.getItem('carno') != 1) {
	          param.append('address_id', address_id)
	        }
	      } else {
	        param.append('address_id', address_id)
	      }
	      if(address_id){
	        param.append('address_id', address_id)
	  
	      }
	  if(this.dialogVisible == true){
		 console.log('12121212address',this.ruleForm.address)
	  	if(!this.ruleForm.shopping_name){
	  		 return alert('请填写收货人')
	  	}
	  	if(!this.ruleForm.shopping_phone){
	  		 return alert('请填写收货人电话')
	  	}
		
		if(typeof this.ruleForm.address === 'string'){
			let addressarr =this.ruleForm.address.split(',')
			if(!addressarr[0] || !addressarr[1] || !addressarr[2]){
				 return alert('请填写收货人省市区')
			}
			param.append('address',this.ruleForm.address)
		}else{
			if(!this.ruleForm.address[0] || !this.ruleForm.address[1] || !this.ruleForm.address[2]){
				 return alert('请填写收货人省市区')
			}
			param.append('address',this.ruleForm.address.join(','))
		}
	  	
	  	if(!this.ruleForm.query){
	  		 return alert('请填写收货人详细地址')
	  	}
	  	
	  	param.append('shopping_name', this.ruleForm.shopping_name)
	  	param.append('shopping_phone',this.ruleForm.shopping_phone)
	  	param.append('ext_number',this.ruleForm.ext_number)
	  	param.append('query',this.ruleForm.query)
	  	
	  }else{
		  
		  
	  	
	  }
	      param.append('express_id', this.selectProductInfo.data.express_id)
	      param.append('price', this.price)
	      param.append('title', title)
	      param.append('number', this.checkParams['data[product][印刷数量][]'])
	      param.append('kuanshu', this.info.kuanshu)
	      param.append('craft_price', this.info.craft_price)
	      param.append('shipping_fee', this.info.shipping_fee)
	      param.append('product_weight', this.info.product_weight)
	      param.append('spec_key_name', this.info.spec_key_name)
	      param.append('goods_price', this.info.goods_price)
	      param.append('packprice', this.info.packprice)
	      param.append('mianshu', this.packnum)
	      param.append('remarks', this.remarks)
		  param.append('filename', $('input[name="fileurl"]').val())
		  this.fileurl =$('input[name="fileurl"]').val();
		 let fileurlarr =this.fileurl .split('/')
		  param.append('file', fileurlarr[fileurlarr.length-1])
	  
	      const {
	        data: res
	      } = await this.$http({
	        method: 'post',
	        url: '/api/car/addorder',
	        data: param
	      })
	      if (res.code) {
			  $('input[name="fileurl"]').val('')
			   $('.ossfile').empty().html('')
			   this.ruleForm.shopping_name='';
			   this.ruleForm.shopping_phone='';
			   this.ruleForm.ext_number='';
			   this.ruleForm.address='';
			   this.ruleForm.query='';
			   if(res.data.status ==1 ){
				   
				param.append('token',  window.localStorage.getItem('token'))
				param.append('order_pid', res.data.order_pid)
				param.append('amount',  res.data.price)
				param.append('payway',  2)
				const { data: res2 } = await this.$http({
				  method: 'post',
				  url: 'api/pays/submit',
				  data: param
				})
				 if (res2.code != undefined) {
					 
					 
				 }else{
					 const div = document.createElement('div')
					 div.innerHTML = res2 // html code
					 document.body.appendChild(div)
					 document.forms.alipaysubmit.submit()
				 }
			
			   }
			 this.$confirm(res.msg, '提示', {
			     confirmButtonText: '继续下单',
			     cancelButtonText: '刷新页面',
			     type: 'warning'
			   })
			   .then(() => {
			  
			   }).then(() => {
			   
			   })
			   .catch(() => {})
	        if (window.sessionStorage.getItem('carid')) {
	          window.sessionStorage.setItem('ok', 'ok')
	          window.sessionStorage.removeItem('carid')
	        }
			
	      }
	      window.fXD = false
	      if (res.code != 1) {
	        this.$confirm(res.msg, '提示', {
	          confirmButtonText: '确定',
	          callback: action => {
	            this.$message({
	              type: 'error'
	            })
	          }
	        })
	      }
	    } else {
	      alert('请先选择商品各个属性')
	      window.fXD = false
	    }
	  },
      // 获取文件名
      copyproduct() {
        let name = $('.select_product_info').text()
            name = name.replace(/\s+/g, '')
            name = name.replace('张/本', '张每本')
            name = name.replace('/', '每')
            let product_name=$('.sy-info-title >.left').text().trim()
           // name = name.replace(this.checkParams['data[product][产品尺寸][]'], this.checkParams['data[product][产品尺寸][]'] + 'mm')
            var Url2 = product_name+'_'+name
        		var oInput = document.createElement('textarea')
        		oInput.value = Url2
        		document.body.appendChild(oInput)
        		oInput.select() // 选择对象
        		document.execCommand('Copy') // 执行浏览器复制命令
        		oInput.className = 'oInput'
        		oInput.style.display = 'none'
        		this.$message('复制产品规格成功', '提示')
        console.log(this.checkParams['data[product][产品尺寸][]'])
      },
	  chongzhi(){
		   this.$router.push('/recharge')
	  },
      // 获取选中的checked值
       Addressselect(value) {
        let optionCheck = value.split('+')[0]?value.split('+')[0]:'';
        let address_id = value.split('+')[1]?value.split('+')[1]:'';
		this.ruleForm.address_id =value;
		console.log('address_id',address_id,value)
        if (optionCheck == 0) {
          this.selectProductInfo.data.region_id = ''
          this.selectProductInfo.data.is_shipping_fee = false
        } else {
          this.queryRegion(optionCheck)
          console.log(1,value)
          console.log(2,optionCheck)
          this.selectProductInfo.data.region_id = optionCheck
          this.selectProductInfo.data.is_shipping_fee = true
        }
        this.queryExpress('', this.selectProductInfo.data.region_id,address_id)
      },
      Expressselect() {
        let optionCheck = $('#expresslist option:selected').attr('value')
        this.selectProductInfo.data.express_id = optionCheck
        this.getPrice()
      },
      // 获取区域
      async queryRegion(addressId) {
        const {
          data: res
        } = await this.$http.post(
          'api/index/geteare/region_id/' +
          addressId +
          '/token/' +
          window.localStorage.getItem('token')
        )
        res.code == 1 ? (this.regionList = res.data) : (this.regionList = {})
         this.selectProductInfo.data.express_id = $('#expresslist option:selected').attr('value')
         $('#expresslist').val(this.selectProductInfo.data.express_id)
         console.log('获取区域',this.selectProductInfo.data.express_id)
      },
      async getId(id) {
        const {
          data: res
        } = await this.$http.get('api/index/getexplst/id/' + id)

        this.selectProductInfo.data.region_id = res.data.id
        this.product()
        // this.proverMsg = res.data.name
      },
      async queryRegionList() {
        const {
          data: res
        } = await this.$http.get('api/index/getexpress')
        this.regionDataList = res.data
        // this.selectProductInfo.data.express_id = this.regionDataList.expressid
        setTimeout(() => {
          this.getId(this.regionDataList.data[0].id)
        }, 1600)
      }
    },
    watch: {
      $route(to, from) {
        let url = window.location.href
        let num = url.indexOf('?')
        this.cateid = url.substr(num + 4)
        this.selectProductInfo.data.product_id = url.substr(num + 4)
        this.price = ''
        this.productName = ''
        $('.mone').text('')
        this.f = false
        this.queryParams()
        this.queryAddress()
        this.queryExpress()
        this.$nextTick(_ => {
          $('.sy-skin .sy-prop')
            .find('li')
            .removeClass('current disabled syc')
          // $('.sy-skin .sy-prop').find('.check').prop('checked','false')
        })
      }
    },
    created() {
      if (this.sflag || window.sessionStorage.getItem('carid')) {
        this.Cflag = true;
      }

      let url = window.location.href
      let num = url.indexOf('?')
      this.baseUrl = 'http://' + window.location.host
      if (num != -1) {
        this.cateid = url.substr(num + 4)
        this.selectProductInfo.data.product_id = url.substr(num + 4)
      } else {
        this.cateid = 0
        this.selectProductInfo.data.product_id = 0
      }
      this.queryParams()
      if (window.localStorage.getItem('token')) {
        this.userInfo()
      }
      this.getzhilei()
	  
    },
    mounted() {
      setTimeout(() => {
        let optionCheck = this.ruleForm.address_id.split('+')[0]
        console.log(1111,optionCheck)
		
        if (optionCheck == 0) {
          this.selectProductInfo.data.region_id = ''
          this.selectProductInfo.data.is_shipping_fee = false
        } else {
          this.selectProductInfo.data.region_id = optionCheck
          this.selectProductInfo.data.is_shipping_fee = true
        }
      }, 1500)
	 
      // if (!this.sflag && !window.sessionStorage.getItem('carid')) {
      //   this.queryRegionList()
      // }
      this.queryAddress()
   const that = this
      window.localStorage.getItem('token')
        ? (that.flag = true)
        : (that.flag = false)
      // 标识是否可以发送请求
      $('.zhouqishuom').on('mouseover mouseout', function(e) {
        if (e.type == 'mouseover') {
          $('.tishi')
            .stop()
            .fadeIn()
        } else if (e.type == 'mouseout') {
          $('.tishi')
            .stop()
            .fadeOut()
        }
      })

      // $(document).on('change','.product_chicun input',function(){

      //     if(that.selectProductInfo.data.product_id == 79){

      //     var chang = $('#chang').val();
      //     var kuan = $('#kuan').val();
      //     var hou = $('#hou').val();

      //     var ii = 0;

      //     if(chang<200 || kuan<160 || hou<50){
      //       ii = 1;
      //     }

      //     if(chang>450 || kuan>630 || hou>280){
      //       ii = 1;
      //     }

      //     if((kuan-hou)<40){
      //         ii = 1;
      //     }
      //   if(ii == 1){
      //       that.ckg = 0
      //   }else {
      //       that.ckg = 1

      //   }
      //  }

      // })

      $('.sy-skin').on('click', '.sy-prop dd li', function() {
        if ($(this).hasClass('disabled') == false) {
          toggImg($(this).text())

          if ($(this).hasClass('region_item')) {
            $(this)
              .addClass('current')
              .siblings('li')
              .removeClass('current')
          } else {
            $(this)
              .toggleClass('current')
              .siblings('li')
              .removeClass('current')
          }
          if ($(this).text() == '铜版纸画册' || $(this).text() == '精品纸画册' || $(this).text() == '双胶纸画册' || $(this).text() == '道林纸画册' || $(this).text() == '皮纹纸画册') {
            let arr = {}
            arr = { '铜版纸画册': '55', '精品纸画册': '56', '双胶纸画册': '54', '道林纸画册': '57', '皮纹纸画册': '58' }
            let id = arr[$(this).text()]

            that.getzhizhang2(id)
          }
          if ($(this).parents('dl').find('dt').text() == '封面握口:') {
            if ($(this).text() == '有') {
              $('.wokou').show()
              $('.wokoucm').show()
            } else {
             $('.wokou').hide()
             $('.wokoucm').hide()
             $('.wokou').val(0)
             that.wokou = 0
            }
          }

          if (
            $(this)
            .parents('dd')
            .siblings('dt')
            .text() != '产品种类:'
          ) {
            if (!$(this).hasClass('region_item')) {
              that.product()
            }
          }
        }
      })

      this.$nextTick(_ => {
        // 小图片点击事件
        $('.smallImgBox').on('click', 'a', function() {
          that.imgUrl = $(this)
            .find('img')
            .attr('src')
        })
        // 下拉框选项
        $('.sy-skin').on('change', '#selBox', function() {
          toggImg($('#selBox').val())
          reBans($(this).val())
        })
        // 下拉框选项
        $('.sy-skin').on('change', '#fmzhileiselBox', function() {
          toggImg($('#fmzhileiselBox').val())
          console.log('封面用纸' + $(this).val())
          reBans('封面用纸' + $(this).val())
        })
        // 下拉框选项
        $('.sy-skin').on('change', '#nwzhileiselBox', function() {
          toggImg($('#nwzhileiselBox').val())
          // reBans('内文用纸'+$(this).val())
          that.product()
        })
        // 下拉尺寸
        $('.sy-skin').on('change', '#selectselBox', function() {
          toggImg($('#selectselBox').val())
          // reBans('内文用纸'+$(this).val())
          that.product()
        })
        // 给种类绑定点击
        $('.sy-skin').on(
          'click',
          '.sy-prop dd .product_zhonglei li',
          async function() {
            if ($(this).hasClass('current')) {
              let queryText = $(this).text()
              reBans(queryText)
              toggImg(queryText)
            } else {
              $.each($('.sy-skin .sy-prop dd ul li'), function(i, e) {
                $(e).removeClass('disabled syc')
              })
              $.each($('input[type=checkbox]'), function(i1, e1) {
                $(e1).removeAttr('disabled')
                $(e1)
                  .parent('label')
                  .removeClass('disabled syc')
              })
              $.each($('.sy-skin input[type=radio]'), function(i3, e2) {
                $(e2).removeAttr('disabled')
                $(e2)
                  .siblings('label')
                  .removeClass('disabled')
                $(e2)
                  .parents('.sy_fdanxuan')
                  .siblings('.sy_fdanxuan')
                  .show()
              })
              that.product()
            }
          }
        )
		
        // 给种产品尺寸定点击
        $('.sy-skin').on(
          'click',
          '.sy-prop dd .product_size li',
          async function() {
             let product_id = that.selectProductInfo.data.product_id

             if (product_id == 79 || product_id == 4 || (product_id == 95 && $(this).text().indexOf('X') >= 0) || (product_id == 5 && $(this).text().indexOf('X') >= 0)) {
               if ($(this).hasClass('current')) {
                 let queryText = $(this).text()
                 if (product_id == 95) {
                   console.log($(this) + '')
                 }
                 reBans(queryText)
                 // toggImg(queryText)
               } else {
                 $.each($('.sy-skin .sy-prop dd ul li'), function(i, e) {
                   $(e).removeClass('disabled syc')
                 })
                 $.each($('input[type=checkbox]'), function(i1, e1) {
                   $(e1).removeAttr('disabled')
                   $(e1)
                     .parent('label')
                     .removeClass('disabled syc')
                 })
                 $.each($('.sy-skin input[type=radio]'), function(i3, e2) {
                   $(e2).removeAttr('disabled')
                   $(e2)
                     .siblings('label')
                     .removeClass('disabled')
                   $(e2)
                     .parents('.sy_fdanxuan')
                     .siblings('.sy_fdanxuan')
                     .show()
                 })
                 that.product()
               }
             } else {
               // let queryText = $(this).text()
               // reBans(queryText)
               // that.product()
             }
          }
        )
        // 给封面用之定点击
        $('.sy-skin').on(
          'click',
          '.sy-prop dd .fmzhi li',
          async function() {
             let product_id = that.selectProductInfo.data.product_id

             if (product_id == 95 || product_id == 5) {
               if ($(this).hasClass('current')) {
                 let queryText = '封面用纸' + $(this).text()

                 reBans(queryText)
                 // toggImg(queryText)
               } else {
                 $.each($('.sy-skin .sy-prop dd ul li'), function(i, e) {
                   $(e).removeClass('disabled syc')
                 })
                 $.each($('input[type=checkbox]'), function(i1, e1) {
                   $(e1).removeAttr('disabled')
                   $(e1)
                     .parent('label')
                     .removeClass('disabled syc')
                 })
                 $.each($('.sy-skin input[type=radio]'), function(i3, e2) {
                   $(e2).removeAttr('disabled')
                   $(e2)
                     .siblings('label')
                     .removeClass('disabled')
                   $(e2)
                     .parents('.sy_fdanxuan')
                     .siblings('.sy_fdanxuan')
                     .show()
                 })
                 that.product()
               }
             } else {
               // let queryText = $(this).text()
               // reBans(queryText)
               // that.product()
             }
          }
        )
		
		
      })

      // 点击切换图片事件

      function toggImg(queryText) {
        for (let key1 in that.imglist) {
          if (that.imglist[key1].img_name == queryText) {
            that.imgUrl = that.imglist[key1].path
          }
        }
      }
      // ban选 必选验证
      async function reBans(queryText) {
        if (queryText) {
          //更新尺寸限制
          var arr = Object.keys(that.chicunlimit);
          if(arr.length>0){
            if(that.chicunlimit[queryText]){

              that.chicun_min_l=that.chicunlimit[queryText]['chicun_min_l'];
              that.chicun_min_w=that.chicunlimit[queryText]['chicun_min_w'];
              that.chicun_max_l=that.chicunlimit[queryText]['chicun_max_l'];
              that.chicun_max_w=that.chicunlimit[queryText]['chicun_max_w'];
            that.chicunlimitdesc='提示：最小尺寸为:'+that.chicun_min_l+'X'+that.chicun_min_w+that.productParams.product.unit+
            ',最大尺寸为:'+that.chicun_max_l+'X'+that.chicun_max_w+that.productParams.product.unit;
            }else{
              //that.productParams.product
             that.chicun_min_l=that.productParams.product['chicun_min_l'];
             that.chicun_min_w=that.productParams.product['chicun_min_w'];
             that.chicun_max_l=that.productParams.product['chicun_max_l'];
             that.chicun_max_w=that.productParams.product['chicun_max_w'];
             that.chicunlimitdesc='提示：最小尺寸为:'+that.chicun_min_l+'X'+that.chicun_min_w+that.productParams.product.unit+
             ',最大尺寸为:'+that.chicun_max_l+'X'+that.chicun_max_w+that.productParams.product.unit;
            }
          }
          let product_id = that.selectProductInfo.data.product_id
          let param = new URLSearchParams()
          param.append('product_id', product_id)
          param.append('cates', queryText)
          param.append('token', window.localStorage.getItem('token'))
          const {
            data: res
          } = await that.$http({
            method: 'post',
            url: 'api/product/productbans',
            data: param
          })
          const {
            data: resu
          } = await that.$http({
            method: 'post',
            url: 'api/product/productreq',
            data: param
          })
          const {
            data: result
          } = await that.$http.post(
            'api/product/productdefs',
            param
          )

          // 默认项
          if (result.code == 1) {
            for (let k in result.data) {
              $.each($('dt'), function(i, v) {
                let dtval = $(v).text()
                dtval = dtval.slice(0, dtval.length - 1)
                if (dtval == k) {
                  $.each(
                    $(v)
                    .siblings('dd')
                    .children('ul')
                    .find('li'),
                    function(i1, el) {
                      for (let i = 0; i < result.data[k].length; i++) {
                        if ($(el).text() == result.data[k][i]) {
                          $(el).removeClass('disabled sys')
                          if (!$(el).hasClass('current')) {
                            $(el)
                              .addClass('current')
                              .siblings('li')
                              .removeClass('current')
                          }
                        }
                      }
                    }
                  )
                  $.each($('input[type=checkbox]'), function(i2, el2) {
                    for (let i = 0; i < result.data[k].length; i++) {
                      if ($(el2).val() == result.data[k][i]) {
                        $(el2).prop('checked', 'true')
                        $(el2).prop('disabled', 'true')
                      }
                    }
                  })
                }
              })
            }
          }

          // 必选

          if (resu.code == 1 && JSON.stringify(resu.data) != '[]') {
            if (JSON.stringify(resu.data) != '[]') {
              $.each($('.sy-skin .sy-prop dd ul li'), function(i, e) {
                $(e).removeClass('disabled syc')
              })
              $.each($('input[type=checkbox]'), function(index, value) {
                $(value).removeAttr('disabled')
                $(value)
                  .parent('label')
                  .removeClass('disabled syc')
              })
              for (let k in resu.data) {
                $.each($('dt'), function(indexInArray, valueOfElement) {
                  let dtval = $(valueOfElement).text()
                  dtval = dtval.slice(0, dtval.length - 1)
                  if (dtval == k) {
                    $.each(
                      $(valueOfElement)
                      .siblings('dd')
                      .children('ul')
                      .find('li'),
                      function(i1, el) {
                        for (let i = 0; i < resu.data[k].length; i++) {
                          if ($(el).text() == resu.data[k][i]) {
                            $(el)
                              .siblings('li')
                              .addClass('disabled syc')
                            $(el)
                              .addClass('current')
                              .siblings('li')
                              .removeClass('current')
                            $(el).addClass('disabled syc')
                          }
                        }
                      }
                    )
                    $.each($('input[type=checkbox]'), function(i2, el2) {
                      for (let i = 0; i < resu.data[k].length; i++) {
                        if ($(el2).val() == resu.data[k][i]) {
                          $(el2).prop('checked', 'true')
                          $(el2).prop('disabled', 'true')
                        }
                      }
                    })
                    $.each($('.sy-skin input[type=radio]'), function(i3, el3) {
                      for (let i = 0; i < resu.data[k].length; i++) {
                        if ($(el3).val() == resu.data[k][i]) {
                          $(el3)
                            .siblings('label')
                            .click()
                          $(el3)
                            .parents('.sy_fdanxuan')
                            .siblings('.sy_fdanxuan')
                            .hide()
                          $(el3).prop('checked', 'true')
                          $(el3).prop('disabled', 'true')
                          $(el3)
                            .siblings('label')
                            .addClass('sy_dx disabled')
                        }
                      }
                    })
                  }
                })
              }
            }
          } else {
            $.each($('.sy-skin .sy-prop dd ul li'), function(i, e) {
              $(e).removeClass('disabled syc')
            })
            $.each($('input[type=checkbox]'), function(index, value) {
              $(value).removeAttr('disabled')
              $(value)
                .parent('label')
                .removeClass('disabled syc')
            })
          }
          // ban选
          if (res.code == 1) {
            if (JSON.stringify(res.data) != '[]') {
              for (let key in res.data) {
                that.checkParams['data[product][' + key + '][]'] = ''
                $.each($('dt'), function(indexInArray, valueOfElement) {
                  let dtval = $(valueOfElement).text()
                  dtval = dtval.slice(0, dtval.length - 1)
                  if (dtval == key) {
                    let li = $(valueOfElement)
                      .siblings('dd')
                      .children('ul')
                      .find('li')
                    $.each(li, function(index, value) {
                      for (let i = 0; i < res.data[key].length; i++) {
                        if ($(value).text() == res.data[key][i]) {
                          $(value).removeClass('current')
                          $(value).addClass('disabled syc')
                        }
                      }
                    })
                    $.each($('input[type=checkbox]'), function(index, value) {
                      for (let i = 0; i < res.data[key].length; i++) {
                        if (
                          $(value)
                          .siblings('span')
                          .text() == res.data[key][i]
                        ) {
                          if ($(value).prop('checked')) {
                            $(value).click()
                          }
                          $(value).attr('disabled', 'true')
                          $(value)
                            .parent('label')
                            .addClass('disabled syc')
                        }
                      }
                    })
                  } else {
                    $(valueOfElement)
                      .siblings('dd')
                      .find('ul')
                      .children('li')
                      .show()
                  }
                })
              }
            } else {
              $.each($('.sy-skin .sy-prop dd ul li'), function(i, e) {
                $(e).removeClass('disabled syc')
              })
            }
          }
        } else {
          that.productName = ''
          that.price = ''
          $.each($('.sy-skin .sy-prop dd ul li'), function(i, e) {
            $(e).removeClass('disabled syc')
          })
          $.each($('input[type=checkbox]'), function(i1, e1) {
            $(e1).removeAttr('disabled')
          })
          $.each($('.sy-skin input[type=radio]'), function(i3, e2) {
            $(e2).removeAttr('disabled')
            $(e2)
              .siblings('label')
              .removeClass('disabled')
            $(e2)
              .parents('.sy_fdanxuan')
              .siblings('.sy_fdanxuan')
              .show()
          })
          $.each($('input[type=checkbox]'), function(index, value) {
            $(value).removeAttr('disabled')
            $(value)
              .parent('label')
              .removeClass('disabled syc')
          })
        }
        that.product()
      }

      $('.sy-skin').on('click', '.fuxuan input', function() {
        let parN = $(this)
          .parents('dl')
          .children('dt')
          .text()
        parN = parN.slice(0, parN.length)
        parN = 'data[product]' + '[' + parN + ']' + '[]'
        let parGY = []
        $('.sy-skin .product_gy input:checked').each(function() {
          $(this)
            .parents('dd')
            .siblings('dt')
            .text()

          let dText = $(this)
            .siblings('span')
            .text()
          parGY.push(dText)
        })
        toggImg($(this).val())

        that.product()
      })

      // 点击单选
      $('.sy-skin').on('click', '.danxuan .sy_fdanxuan label', function() {
        if (!$(this).hasClass('disabled')) {
          let index = $(this).index()
          let dtname = $(this)
            .parents('dd')
            .siblings('dt')
            .text()
          dtname = dtname.slice(0, dtname.length - 1)
          $(this)
            .parents('.sy_fdanxuan')
            .find('.dy')
            .show()
          $(this)
            .parents('.sy_fdanxuan')
            .siblings('.sy_fdanxuan')
            .find('.dy')
            .hide()
          $.each(
            $(this)
            .parents('.sy_fdanxuan')
            .siblings('.sy_fdanxuan')
            .find('.dy')
            .children('input'),
            function(indexInArray, valueOfElement) {
              $(valueOfElement).val('')
            }
          )
          that.product('data[product][' + dtname + '][]')

          let radio = $(this).siblings('input')
          if ($(this).hasClass('disabled') == false) {
            if ($(this).hasClass('sy_dx') == false) {
              $(this)
                .addClass('sy_dx')
                .parents('.sy_fdanxuan')
                .siblings('.sy_fdanxuan')
                .find('label')
                .removeClass('sy_dx')
            } else {
              $(this).removeClass('sy_dx')
              $.each($(this).parents('.sy_fdanxuan'), function(
                indexInArray,
                valueOfElement
              ) {
                $(valueOfElement)
                  .children('.dy')
                  .hide()
              })
            }
          }
        }
        toggImg($(this).text())
      })

      let t

      function computTime(obj) {
        t = setTimeout(() => {
          // if($('.product_chicun').is(':visible')){
          //   var chang=$('#chang').val();
          //   var kuan=$('#kuan').val();
          //   if((chang<that.chicun_min_l && kuan<that.chicun_min_l ) || (chang<that.chicun_min_l && chang<that.chicun_min_l )|| (kuan<that.chicun_min_l && kuan<that.chicun_min_l ) ){
          //     console.log('bumanzu')

          //   }


          // }
          if ((that.selectProductInfo.data.product_id == 79 || that.selectProductInfo.data.product_id == 4) && $('.product_chicun').is(':visible')) {
            $('.kgh').text('')
            $('.money').text('')
            if (($('#kuan').val() - $('#hou').val()) <= 40) {
              $('.money').text('请联系客服询价')
              $('.kgh').text('请联系客服询价')
              $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                $(this).children('dd').children('ul').find('li').addClass('disabled syc')
              })
              return false
            } else {
              $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                $(this).children('dd').children('ul').find('li').removeClass('disabled syc')
              })
            }
            // 手提袋成品尺寸：高＞厚/2+4cm
            if (parseInt($('#chang').val()) <= (parseInt($('#hou').val()) / 2 + 4)) {
              $('.money').text('请联系客服询价')
              $('.kgh').text('请联系客服询价')
              $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                $(this).children('dd').children('ul').find('li').addClass('disabled syc')
              })
              return false
            } else {
              $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                $(this).children('dd').children('ul').find('li').removeClass('disabled syc')
              })
            }

            if (obj.attr('id') == 'chang') {
              if (obj.val() < 200 || obj.val() > 450) {
                $('.kgh').text('请联系客服询价')
                $('.money').text('请联系客服询价')

                $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                  $(this).children('dd').children('ul').find('li').addClass('disabled syc')
                })

                return false
              } else {
                $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                  $(this).children('dd').children('ul').find('li').removeClass('disabled syc')
                })
              }
            }
            if (obj.attr('id') == 'kuan') {
              if (obj.val() < 160 || obj.val() > 630) {
                $('.money').text('请联系客服询价')

                $('.kgh').text('请联系客服询价')
                $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                  $(this).children('dd').children('ul').find('li').addClass('disabled syc')
                })
                return false
              } else {
                $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                  $(this).children('dd').children('ul').find('li').removeClass('disabled syc')
                })
              }
            }
            if (obj.attr('id') == 'hou') {
              if (obj.val() < 50 || obj.val() > 450) {
                $('.money').text('请联系客服询价')
                $('.kgh').text('请联系客服询价')
                $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                  $(this).children('dd').children('ul').find('li').addClass('disabled syc')
                })
                return false
              } else {
                $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                  $(this).children('dd').children('ul').find('li').removeClass('disabled syc')
                })
              }
            }

            var chang = $('#chang').val()
            var kuan = $('#kuan').val()
            var hou = $('#hou').val()

            if (chang < 200 || chang > 450) {
              $('.kgh').text('请联系客服询价')
              $('.money').text('请联系客服询价')

              $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                $(this).children('dd').children('ul').find('li').addClass('disabled syc')
              })

              return false
            }
            if (kuan < 160 || kuan > 630) {
              $('.money').text('请联系客服询价')

              $('.kgh').text('请联系客服询价')
              $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                $(this).children('dd').children('ul').find('li').addClass('disabled syc')
              })
              return false
            }

            if (hou < 50 || hou > 450) {
              $('.money').text('请联系客服询价')
              $('.kgh').text('请联系客服询价')
              $('.sy-skin').children('.sy-prop:gt(1)').each(function() {
                $(this).children('dd').children('ul').find('li').addClass('disabled syc')
              })
              return false
            }

            if ((parseInt(kuan) + parseInt(hou)) * 2 >= 1020) {
              if (!$('.product_ys li').eq(2).hasClass('current')) {
                $('.product_ys li').eq(1).addClass('current')
              }
              // disabled syc
              $('.product_ys li').eq(0).removeClass('current')
              $('.product_ys li').eq(0).addClass('disabled')
              $('.product_ys li').eq(0).addClass('syc')

              //   return false;
            }
          }

          that.product()
        }, 700)
      }

      function stopTime() {
        clearTimeout(t)
      }

      // 输入尺寸

      $('.sy-skin').on('change', '.dy input', function(e) {
        if($(this).is(':focus')){
           stopTime()
        }else{
           computTime($(this))
        }

      })

      that.product = function(obj) {
        that.checkParams = {}
        const key = []
        let parg = []
        var cpgy = ''

        $('.sy-skin .product_gy input:checked').each(function() {
          cpgy = $(this)
            .parents('dd')
            .siblings('dt')
            .text()
          cpgy = cpgy.slice(0, cpgy.length - 1)
          cpgy = 'data[product]' + '[' + cpgy + ']' + '[]'

          let dText = $(this)
            .siblings('span')
            .text()
          parg.push(dText)
        })

        if (parg == '') {
          delete that.checkParams[cpgy]
        } else {
          that.checkParams[cpgy] = parg
        }

        let allInput = $('.sy-skin .dy input')
        $.each(allInput, function(indexInArray, valueOfElement) {
          $(valueOfElement).click(function() {
            $(this).focus()
          })
        })
        let allIpt = $('.dy:visible').children('input')
        $.each(allIpt, (i, ele) => {
          if (
            $(this)
            .parent('.dy')
            .css('display') == 'block'
          ) {
            allIpt.push(ele)
          }
        })
        $.each(allIpt, (i, e) => {
          let cId = $(e).attr('id')
          if ($('#chang').length && $('#kuan').length) {
            if ($('#chang').val() - 0 > that.chicun_max_l) {
              $('#chang').val(that.chicun_max_l)
            }
            if ($('#kuan').val() - 0 > that.chicun_max_w) {
              $('#kuan').val(that.chicun_max_w)
            }
            if ($('#chang').val() - 0 < that.chicun_min_l) {
              $('#chang').val(that.chicun_min_l)
            }
            if ($('#kuan').val() - 0 < that.chicun_min_w) {
              $('#kuan').val(that.chicun_min_w)
            }

          }
          if (!$(e).val()) {
            $(e).click()
            return false
          }
        })

        let flag = true
        let tname = ''
        $.each($('.sy-skin .dy'), function(i5, e5) {
          if ($(e5).css('display') == 'block') {
            tname = $(e5)
            $.each($(e5).children('input'), function(i6, e6) {
              if (
                $(e6)
                .val()
                .trim()
              ) {
                return (flag = true)
              } else {
                return (flag = false)
              }
            })
          }
        })
        // 处理单选选中项
        let fmoname = ''
        let fmoVal = ''

        setTimeout(() => {
          $.each($('.sy-skin .sy_fdanxuan').find('input:radio'), function(
            i8,
            e8
          ) {
            if (
              $(e8)
              .siblings('label')
              .hasClass('sy_dx')
            ) {
              fmoname = $(e8)
                .parents('dd')
                .siblings('dt')
                .text()
              fmoname = fmoname.slice(0, fmoname.length - 1)
              fmoVal = $(e8).val()
              that.checkParams[
                'data[product]' + '[' + fmoname + ']' + '[]'
              ] = fmoVal
            }
          })
        }, 0)

        // 处理 select选项
        that.$nextTick(_ => {
          if ($('#selBox').val()) {
            let cp = $('#selBox')
              .parents('dd')
              .siblings('dt')
              .text()
            cp = cp.slice(0, cp.length - 1)
            cp = 'data[product]' + '[' + cp + ']' + '[]'
            that.checkParams[cp] = $('#selBox').val()
          }
        })
        that.$nextTick(_ => {
          if ($('#fmzhileiselBox').val()) {
            let cp = $('#fmzhileiselBox')
              .parents('dd')
              .siblings('dt')
              .text()
            cp = cp.slice(0, cp.length - 1)
            cp = 'data[product]' + '[' + cp + ']' + '[]'
            that.checkParams[cp] = $('#fmzhileiselBox').val()
          }
        })
        that.$nextTick(_ => {
          if ($('#nwzhileiselBox').val()) {
            let cp = $('#nwzhileiselBox')
              .parents('dd')
              .siblings('dt')
              .text()
            cp = cp.slice(0, cp.length - 1)
            cp = 'data[product]' + '[' + cp + ']' + '[]'
            that.checkParams[cp] = $('#nwzhileiselBox').val()
          }
        })
        that.$nextTick(_ => {
          if ($('#selectselBox').val()) {
            let cp = $('#selectselBox')
              .parents('dd')
              .siblings('dt')
              .text()
            cp = cp.slice(0, cp.length - 1)
            cp = 'data[product]' + '[' + cp + ']' + '[]'
            that.checkParams[cp] = $('#selectselBox').val()
          }
        })

        if (flag) {
          if (tname) {
            let fname = $(tname)
              .parents('dd')
              .siblings('dt')
              .text()

            fname = fname.slice(0, fname.length - 1)
            that.checkParams['data[product]' + '[' + fname + ']' + '[]'] = ''
            $.each($(tname).children('input'), function(i, ele) {
              that.checkParams['data[product]' + '[' + fname + ']' + '[]'] +=
                $(ele).val() + 'X'
            })
            that.checkParams[
              'data[product]' + '[' + fname + ']' + '[]'
            ] = that.checkParams[
              'data[product]' + '[' + fname + ']' + '[]'
            ].slice(
              0,
              that.checkParams['data[product]' + '[' + fname + ']' + '[]']
              .length - 1
            )
          }

          $('.sy-skin dl').each(function(i, ele) {
            let paramName = $(ele)
              .children('dt')
              .text()
              .replace(/\s+/g, '')
            paramName = paramName.slice(0, paramName.length - 1)
            paramName = 'data[product]' + '[' + paramName + ']' + '[]'
            $(this)
              .find('.current')
              .each(function(i2, ele2) {
                let paramVal = $(this)
                  .text()
                  .trim()
                if (paramVal == '自定义') {
                  var parname = $(this)
                    .parents('dd')
                    .siblings('dt')
                    .text()

                  if (parname == '产品尺寸:') {
                    let c =
                      $(this)
                      .siblings('.dy')
                      .find('input')
                      .eq(0)
                      .val()
                      .trim() - 0
                    let k =
                      $(this)
                      .siblings('.dy')
                      .find('input')
                      .eq(1)
                      .val()
                      .trim() - 0
                    if (
                      $(this)
                      .siblings('.dy')
                      .find('input')
                      .eq(2).length
                    ) {
                      var h =
                        $(this)
                        .siblings('.dy')
                        .find('input')
                        .eq(2)
                        .val()
                        .trim() - 0
                    }
                    if (c > that.chicun_max_l) {
                       c = that.chicun_max_l
                    }
                    if (k > that.chicun_max_w) {
                       k = that.chicun_max_w
                    }
                    if(c<that.chicun_min_l){
                      c=that.chicun_min_l
                    }
                    if(k<that.chicun_min_w){
                      k=that.chicun_min_w
                    }


                    if (
                      $(this)
                      .siblings('.dy')
                      .find('input')
                      .eq(0)
                      .val()
                      .trim() !== '' &&
                      $(this)
                      .siblings('.dy')
                      .find('input')
                      .eq(1)
                      .val()
                      .trim() !== ''
                    ) {
                      if (
                        $(this)
                        .siblings('.dy')
                        .find('input')
                        .eq(2).length
                      ) {
                        that.checkParams[paramName] = c + 'X' + k + 'X' + h
                      } else {
                        that.checkParams[paramName] = c + 'X' + k
                      }
                    } else {
                      that.checkParams[paramName] = 'X'
                    }
                  } else if (parname == '印刷数量:') {
                    let sl = $(this)
                      .siblings('.dy')
                      .find('input')
                      .eq(0)
                      .val()
                      .trim()
                    if (sl < that.minNum) {
                      sl = 0
                      $(this)
                        .siblings('.dy')
                        .find('input')
                        .eq(0)
                        .val('')

                      $(this)
                        .siblings('.dy')
                        .find('input')
                        .eq(0)
                        .click()
                    }
                    that.checkParams[paramName] = sl
                  }
                  that.checkParams['data[product][款数][]'] = that.kuanshu
                } else {
                  that.checkParams[paramName] = paramVal
                  that.checkParams['data[product][款数][]'] = that.kuanshu
                }
              })
          })
          that.checkParams['data[product][款数][]'] = that.kuanshu
          var product_id = that.selectProductInfo.data.product_id
           if (product_id == 95 || product_id == 5) {
             if (that.npnum) {
               that.checkParams['data[product][内文P数][]'] = that.npnum
             }
             if (that.tjnum) {
               that.checkParams['data[product][烫金工艺][]'] = that.tjnum
             }
             if (that.wokou) {
               that.checkParams['data[product][封面握口][]'] = that.wokou
             }
           }

          $('.sy-skin .sy-prop dt').removeClass('er_bor')
          for (let i = 0; i < that.bixuan.length; i++) {
            if (
              this.checkParams[
                'data[product]' + '[' + that.bixuan[i] + ']' + '[]'
              ] == undefined
            ) {
              $.each($('.sy-skin .sy-prop dt'), function(index, e) {
                if (
                  $(e)
                  .text()
                  .slice(0, $(e).text().length - 1) == that.bixuan[i]
                ) {
                  $(e).addClass('er_bor')
                }
              })
            }
          }
          console.log($('#fmzhileiselBox').val())
          if ($('#zidingy').val()) {
            console.log(122212)
            $('#zidingy').parents('dl').find('dt').removeClass('er_bor')
          }
          if ($('#zidingy2').val()) {
          that.checkParams['data[product][张数工艺][]'] = $('#zidingy2').val()
            $('#zidingy2').parents('dl').find('dt').removeClass('er_bor')
          }
          if ($('#fmzhileiselBox').val()) {
            console.log(122212)
            $('#fmzhileiselBox').parents('dl').find('dt').removeClass('er_bor')
          }
          if ($('#nwzhileiselBox').val()) {
            $('#nwzhileiselBox').parents('dl').find('dt').removeClass('er_bor')
          }
if ($('#selectselBox').val()) {
            $('#selectselBox').parents('dl').find('dt').removeClass('er_bor')
          }
          // 发送请求
          setTimeout(() => {
            that.getPrice()
          }, 1)
        } else {
          that.price = ''
          that.productName = ''
        }
      }

      $('.sy-skin').on('click', '.save_count', function() {
        $(this)
          .siblings('.dy')
          .css('display', 'block')
        $(this)
          .siblings('li')
          .removeClass('current')
        $(this)
          .siblings('li')
          .click(function() {
            $(this)
              .siblings('.dy')
              .css('display', 'none')
            $(this)
              .siblings('.dy')
              .children('input')
              .val('')
          })
      })
      $('.btn-group').on('mouseover mouseout', '.small_ewm', e => {
        if (e.type == 'mouseover') {
          $('.large_ewm').show()
        } else {
          $('.large_ewm').hide()
        }
      })
    }
  }
</script>

<style lang="less" scoped>
  .disabled {
    cursor: not-allowed !important;
  }

  .syc {
    background-color: #ddd;
    color: #999;
  }

  .distpicker-address-wrapper {
    margin-left: 70px;
    margin-bottom: 1px;
  }

  .breadcrumbs {
    width: 100%;
    height: 40px;

    .w {
      line-height: 40px;
      font-size: 12px;
      color: #333;
    }
  }

  .body {
    background-color: #fff;
    width: 100%;
    min-height: 623px;

    input[type='radio']+label::before {
      content: '\a0';
      /*不换行空格*/
      display: inline-block;
      vertical-align: middle;
      font-size: 12px;
      width: 0.5em;
      height: 0.5em;
      margin-right: 0.4em;
      border-radius: 50%;
      border: 1px solid #ccc;
      text-indent: 0.15em;
      line-height: 1;
      padding: 0.2em;
    }

    input[type='radio']:checked+.sy_dx::before {
      background-color: #01cd78;
      border-color: #01cd78;
      background-clip: content-box;
    }

    input[type='radio'] {
      position: absolute;
      clip: rect(0, 0, 0, 0);
    }

    label {
      cursor: pointer;
    }

    .sy-detail-bd {
      padding-bottom: 30px;
      padding-top: 20px;

      .sy-item-info-l {
        margin-right: 20px;
        width: 400px;
        float: left;

        .sy-gallery {
          width: 400px;
          height: 475px;

          .sy-booth {
            position: relative;
            margin-bottom: 10px;

            a {
              display: block;
              width: 400px;
              height: 400px;
              width: 100%;
            }
          }

          .sy-thumb {
            width: 100%;
            height: 62px;

            .arrow-left,
            .arrow-right {
              width: 30px;
              height: 60px;
              background: #000;
              opacity: 0.5;
            }

            .arrow-left {
              float: left;
              background: url('../../assets/detail/info_img/arrow-left.png') center no-repeat;
              cursor: pointer;
            }

            .arrow-right {
              float: right;
              background: url('../../assets/detail/info_img/arrow-right.png') center no-repeat;
              cursor: pointer;
            }

            ul {
              li {
                box-sizing: border-box;
                width: 58px;
                height: 58px;
                float: left;
                margin-right: 10px;

                a {
                  display: block;

                  img {
                    width: 100%;
                  }
                }
              }

              .first {
                margin-left: 5px;
              }

              .last {
                margin-right: 0;
              }

              li:hover {
                border: 1px solid #a77c5a;
              }
            }
          }
        }
      }

      .sy-item-info-r {
        position: relative;
        width: 880px;
        background: #fff;
        float: left;

        .select_product_info {
          font-size: 14px;
          line-height: 18px;
          margin-top: 10px;
          padding-left: 50px;
          color: #333;
          width: 80%;
        }

        .sy-info-title {
          .left {
            float: left;
            font-size: 18px;
            color: #333;
            width: 200px;
            height: 22px;
            line-height: 22px;
            margin-bottom: 10px;
          }

          .right {
            float: right;
            width: 180px;
            height: 22px;

            div {
              float: right;

              a {
                display: inline-block;
                margin-left: 15px;
                height: 22px;
                vertical-align: middle;

                span {
                  font-size: 12px;
                  margin-right: 4px;
                  vertical-align: middle;
                }
              }
            }
          }
        }

        .sy-info-price {
          position: relative;
          height: auto;
          padding: 10px 0;
          background-color: #eef2f5;

          .money {
            font-size: 22px;
            color: #000000;
            font-weight: bold;
          }

          .left {
            float: left;
            height: 70px;
            padding-left: 12px;
            width: 100%;

            .price {
              height: 42px;
              line-height: 42px;
              font-size: 12px;
              color: #666;
              width: 100%;

              b {
                color: #fff;
                padding: 4px;
                background-color: pink;
                position: relative;
                border-radius: 4px;
                margin-left: 10px;
              }

              b::before {
                content: '';
                position: absolute;
                bottom: 0;
                left: -5px;
                width: 0;
                height: 0;
                border: 6px solid;
                border-color: transparent transparent pink;
              }

              span,
              strong {
                margin-right: 7px;
              }

              strong {
                font-size: 32px;
                color: red;
              }
            }

            .favorable {
              float: right;
              margin-top: -30px;
              margin-right: 50px;
              span {
                margin-right: 7px;
              }

              a {
                display: inline-block;
                width: 70px;
                height: 24px;
                line-height: 24px;
                text-align: center;
                color: #fff;
                background-color: #fe6b6b;
              }
            }
          }
        }

        .sy-skin {
          margin-top: 10px;

          .er_bor {
            border: 2px solid pink;
          }

          .sy-prop {
            box-sizing: border-box;
            padding-top: 2px;
            margin-bottom: 1px;

            .fuxuan {
              span {
                margin-right: 15px;
                margin-left: 5px;
              }

              .check {
                -webkit-appearance: none;
                appearance: none;
                outline: none;
                width: 15px;
                height: 15px;
                cursor: pointer;
                vertical-align: center;
                background: #fff;
                border: 1px solid #ccc;
                position: relative;
              }

              .check:checked::after {
                content: '\2714';
                display: block;
                position: absolute;
                top: 1px;
                left: 0px;
                right: 0;
                bottom: 0;
                width: 18px;
                height: 18px;
                line-height: 10px;
                color: #a77c5a;
                font-size: 18px;
              }
            }

            #addressSelect {
              outline: #a77c5a;
              width: 500px;
              height: 35px;
              border: 1px solid #a77c5a;

              option {
                height: 20px;
              }
            }

            dt {
              float: left;
              min-width: 52px;
              margin: 5px 10px 0 0;
            }

            dd {
              float: left;
              width: 650px;

              strong {
                font-size: 16px;
                color: #e83030;
              }

              .dy {
                float: left;
                display: none;

                #chang,
                #kuan,
                #chang1,
                #kuan1,
                #hou,
                #hou1 {
                  border: 1px solid #ccc;
                  width: 50px;
                  height: 28px;
                  margin-left: 30px;
                  text-align: center;
                  margin: 0;
                }

                #chang {
                  margin-left: 15px;
                }
              }

              ul {
                li {
                  box-sizing: border-box;
                  float: left;
                  padding: 2px 5px;
                  border: 1px solid #ddd;
                  margin-right: 5px;
                  margin-bottom: 5px;
                  cursor: pointer;

                  a {
                    font-size: 12px;
                    color: #666;
                  }
                }
              }

              .save_count {
                float: left;
              }

              #zidingy {
                border: 1px solid #ccc;
                width: 80px;
                height: 28px;
                text-align: center;
              }
              #zidingy2 {
                border: 1px solid #ccc;
                width: 80px;
                height: 28px;
                text-align: center;
              }
            }
          }
          .footers{
            dd{
              width: 200px;
            }
          }

          .zq {
            position: relative;

            .tishi {
              display: none;
              z-index: 999;
              position: absolute;
              top: 28px;
              left: 45px;
              width: 302px;
              height: 34px;
              background-color: #8df8b1;
              color: #a77c5a;
              padding: 10px 8px 10px 12px;
              font-size: 12px;
            }

            .tishi::before {
              content: '';
              position: absolute;
              right: 12px;
              top: -15px;
              width: 0;
              height: 0;
              border-left: 8px solid transparent;
              border-right: 8px solid transparent;
              border-bottom: 8px solid #8df8b1;
              border-top: 8px solid transparent;
            }
          }
        }

        .btn-group {
          margin: 20px 0;

          .xiadan,
		  .addcar,
          .gouwuche {
            width: 200px;
            height: 50px;
            font-size: 18px;
            color: #fff;
          }

          .xiadan {
            background-color: #a77c5a;
            margin-right: 20px;
          }
		  .addcar {
		    background-color: red;
		    margin-right: 20px;
		  }

          .sy_sh {
            display: inline-block;

            a {
              margin-left: 3px;
            }

            .small_ewm {
              position: relative;

              .large_ewm {
                display: none;
                position: absolute;
                top: -180px;
                right: -140px;
              }
            }
          }
        }
      }
    }

    .current {
      background-color: #a77c5a;
      color: #fff;
    }
  }
.piliang{
  padding: 5px;
  background-color: indianred;
  color: white;
}
.piliang2{
  padding: 5px;
  background-color: indianred;
  color: white;
}
  #selBox {
    width: 200px;
    height: 35px;

    option {
      font-size: 13px;
    }
  }

  .di {
    width: auto !important;

  }

  .by_bg1 {
    position: absolute;
    top: 0;
    left: 0;
    width: 400px;
    height: 400px;
    background: url('../../assets/detail/info_img/by_bg.png');
  }

  .coustor {
    width: 180px;
    padding: 5px;
    border: 1px solid #bbb;
  }
  .coustor2 {
    width: 200px;
}
  .body .sy-detail-bd .sy-item-info-r .sy-skin .sy-prop dd ul li[data-v-206732c0] {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      float: left;
      padding: 2px 5px;
      border: 1px solid #ddd;
      margin-right: 5px;
      margin-bottom: 5px;
      cursor: pointer;
  }
  .sy-prop dd ul li[data-v-206732c0] {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      float: left;
      padding: 2px 5px;
      border: 1px solid #ddd;
      margin-right: 5px;
      margin-bottom: 5px;
      cursor: pointer;
  }
  .sy-prop dd ul li {
      -webkit-box-sizing: border-box;
      box-sizing: border-box;
      float: left;
      padding: 2px 5px;
      border: 1px solid #ddd;
      margin-right: 5px;
      margin-bottom: 5px;
      cursor: pointer;
  }
  .help{
	  float: right;
	    margin-right: 350px;
	    margin-top: -30px;
  }
  .help a{
	    width: 70px;
	    height: 24px;
	    line-height: 24px;
	    text-align: center;
	    color: #fff;
	    background-color: #fe6b6b;
		margin: 10px;
		padding: 3px 10px;
  }
  .filebtn{
	  width: 500px;
	  height: 50px;
	  border: 2px dashed  #666;
	  border-radius: 5px;
	  display: block;
	  line-height: 50px;
	  text-align: center;
  }
  a :hover{
  	  background-color: #a77c5a;
  
  }
  .ossfile {
	  .progress {
	  	  width: 100%;
	  }
  }
  a {
	  cursor: pointer;
  }
  .video{
	  background-color: black;
  }
  .el-form-item{
	  margin-bottom: 0px !important;
  }
  .input_line {
	  display:inline-block !important;
	  width: 200px !important;
  }
  .el-form-item__label{
	  padding:1px !important;
  }
</style>
